<template>
  <div id="townHall" class="margin-subpages">
    <div v-if="reelsEnabled" class="th-content-nav" role="tablist" :aria-label="$t('happilyVillage.reels.townhall_content')">
      <button type="button" role="tab" :aria-selected="contentMode === 'posts'" :class="{ active: contentMode === 'posts' }" @click="contentMode = 'posts'">
        <i class="el-icon-chat-line-square" aria-hidden="true" /> {{ $t('happilyVillage.reels.posts') }}
      </button>
      <button type="button" role="tab" :aria-selected="contentMode === 'reels'" :class="{ active: contentMode === 'reels' }" @click="contentMode = 'reels'">
        <i class="el-icon-video-camera" aria-hidden="true" /> {{ $t('happilyVillage.reels.reels') }}
      </button>
    </div>
    <div v-if="contentMode === 'posts'" class="pt-24 px-20 pb-16 hv-chart-card">
      <div class="sub-title px-12">
        <span class="fs-24">{{
          $utils("addCommasInNumber", townhall_all)
        }}</span>
        {{ $t("happilyVillage.Knowledge_Sharing_Interactions") }}
      </div>
      <div class="relative" style="height: 240px">
        <div class="center absolute-mid" v-if="loadingChartStatus">
          <loading-even></loading-even>
        </div>
        <canvas
          ref="townHallBarchart"
          height="240px"
          class="barchart-style"
        ></canvas>
      </div>
    </div>
    <template v-if="contentMode === 'posts'">
    <div class="th-inbox-toggle">
      <div class="th-inbox-pill" :class="{ on: useInbox }">
        <i class="el-icon-s-fold th-inbox-ic" aria-hidden="true"></i>
        <span class="th-inbox-lbl">Inbox view</span>
        <span class="th-inbox-beta">Beta</span>
        <el-switch v-model="useInbox" active-color="#6C30CC"></el-switch>
      </div>
    </div>
    <TownHallInbox v-if="useInbox" :reels-enabled="reelsEnabled" @compose="createModal" @edit="cloneTopic($event, 'edit')" />
    <template v-else>
    <div id="townHall" class="mt-8">
      <div class="sub-title">
        <span class="fs-24">{{
          $utils("addCommasInNumber", townHallResults)
        }}</span>
        &nbsp;{{ $t("happilyVillage.Town_Hall_Topics") }}
      </div>
      <div class="flex-row-between mt-14">
        <div class="relative">
          <!-- @keyup.native="typeingSearchTownhall" -->
          <el-input
            class="input-style"
            style="height: 40px"
            autosize
            :placeholder="$t('happilyVillage.Search')"
            v-model="inputSearchTownhall"
            clearable
          ></el-input>
          <!-- <img
            @click="exportTable('townHall')"
            :src="$utils('icons', 'ic_xls_download')"
            class="icon-export"
          /> -->
          <download-progress :active="downloadTownHallBar"></download-progress>
        </div>
        <div class="flex-center">
          <el-dropdown
            @command="createModal"
            trigger="click"
            class="create"
          >
            <el-button type="primary" class="create-btn">
              <span class="fs-20 fw-700 mr-6">+</span>{{ $t("happilyVillage.Create") }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu style="width: 140px" slot="dropdown">
              <el-dropdown-item command="Topic">
                <span class="fs-14">{{ $t("happilyVillage.New_Topic") }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="Poll">
                <span class="fs-14">{{ $t("happilyVillage.New_Poll") }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="Checklist">
                <span class="fs-14">{{
                  $t("happilyVillage.New_Checklist")
                }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="reelsEnabled" command="Reel" divided>
                <span class="fs-14"><i class="el-icon-video-camera" aria-hidden="true" /> {{ $t("happilyVillage.reels.new_reel") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="mt-12">
        <div class="townhall-table-wrapper">
          <el-table
            class="table-happily-village townhall-sessions-table"
            :data="townHallShowing"
            style="width: 100%"
            @sort-change="townHallTopicSort"
            :empty-text="
              loadingTownHallTable
                ? ' '
                : inputSearchTownhall === ''
                ? $t('happilyVillage.No_topics_or_polls')
                : $t('happilyVillage.No_results_found')
            "
          >
          <el-table-column
            :label="$t('happilyVillage.Name')"
            sortable="custom"
            width="284"
            prop="title"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.huddles"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <span
                    v-for="(data, index) in scope.row.huddles"
                    :key="huddleDisplayKey(data, index)"
                  >
                    <span v-if="index < 2" :class="`${spanBgColor(data)}`">{{
                      spanTextTag(data)
                    }}</span>
                    <span v-else-if="index == 2" class="span-tag span-normal"
                      >+ {{ scope.row.huddles.length - 2 }}</span
                    >
                  </span>
                </span>
                <span
                  class="name-medium cursor-pointer"
                  @click.prevent="showCommentModal(scope.row)"
                  :style="$utils('fontStyle', scope.row.title)"
                  >{{ scope.row.title }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Creator')"
            width="110"
            prop="create_name"
          >
            <template slot-scope="scope">
              <div class="normal ellipsis"
              :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.create_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Type')"
            width="125"
            prop="type"
          >
            <template slot-scope="scope">
              <span class="qd-type-pill" :class="'th-type-' + (scope.row.type || 'topic')">
                {{
                  scope.row.type.charAt(0).toUpperCase() +
                  scope.row.type.slice(1)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Views')"
            align="right"
            width="82"
            prop="read"
          >
            <template slot-scope="scope">
              <div class="normal mr-15">
                {{ $utils("addCommasInNumber", scope.row.read) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Engagement')"
            align="right"
            width="180"
            prop="new_comments"
          >
            <template slot-scope="scope">
              <div
                @click.prevent="showCommentModal(scope.row)"
                class="normal mr-10 engagement-link cursor-pointer underline"
              >
                <template v-if="scope.row.type === 'poll'">
                  {{ $utils("addCommasInNumber", scope.row.votes) }} {{ $t("happilyVillage.votes") }} •
                  {{ $utils("addCommasInNumber", scope.row.new_comments) }} {{ scope.row.new_comments === 1 ? $t("happilyVillage.comment") : $t("happilyVillage.comments") }}
                </template>
                <template v-else>
                {{ $utils("addCommasInNumber", scope.row.new_comments) }}
                  {{ scope.row.new_comments === 1 ? $t("happilyVillage.comment") : $t("happilyVillage.comments") }}
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            sortable="custom"
            :label="$t('happilyVillage.Date_and_Time')"
            align="right"
            width="165"
            prop="create_date"
          >
            <template slot-scope="scope">
              <div class="normal last">
                {{ removeYear(scope.row.createdate) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('happilyVillage.Actions')"
            width="90"
            align="center"
          >
            <template slot-scope="scope">
              <div class="campaign-actions-cell">
                <el-dropdown
                  trigger="click"
                  placement="bottom-end"
                  @command="handleTopicActionCommand($event, scope.row)"
                >
                  <button
                    type="button"
                    class="campaign-actions-trigger"
                    :title="$t('happilyVillage.Topic_actions')"
                  >
                    <i class="el-icon-more"></i>
                  </button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="duplicate">{{ $t("happilyVillage.Duplicate") }}</el-dropdown-item>
                    <el-dropdown-item v-if="canEditPost(scope.row)" command="edit">{{ $t("happilyVillage.Edit") }}</el-dropdown-item>
                    <el-dropdown-item command="delete">{{ $t("happilyVillage.Delete") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingTownHallTable">
          <loading-even></loading-even>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            @current-change="handleCurrentTopicsChange"
            :current-page="1"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            :total="townHallResults"
          ></el-pagination>
          <span class="results-status"
            >{{ townHallShowing.length > 10 ? 10 : townHallShowing.length }}
            {{ $t("happilyVillage.results_from") }}
            {{ $utils("addCommasInNumber", townHallResults) }}
            {{ $t("happilyVillage.results") }}</span
          >
        </div>
      </div>
    </div>
    </template>
    </template>
    <TownHallReelOutbox
      v-else-if="reelsEnabled"
      ref="reelOutbox"
      :company-data="companyData"
      @create="openReelStudio()"
      @edit="openReelStudio"
    />
    <div class="topic-modal">
      <el-dialog :visible.sync="addTopicModal" width="930px">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="aq-preview-eyebrow">{{ $t("happilyVillage.Preview_on_Mobile") }}</div>
            <div class="body">
              <div
                v-if="!$utils('watchingTrim', topicForm.title)"
                class="bg-skeleton height-32"
              ></div>
              <div v-else class="fc-404243 fs-18 fw-900 word-break">
                {{ topicForm.title.trim() }}
              </div>
              <div v-if="!topicDescriptionStripped">
                <div class="bg-skeleton height-25 mt-24"></div>
                <div class="bg-skeleton height-25 mt-6"></div>
                <div
                  class="bg-skeleton height-25 mt-6"
                  style="width: 70%"
                ></div>
              </div>
              <div v-else class="mt-10 word-break">
                <MarkdownView :source="topicForm.description" />
              </div>
              <div class="fc-6C6C6C fs-12">
                <div
                  class="flex mb-24"
                  :class="`${
                    !topicDescriptionStripped
                      ? 'mt-32'
                      : 'mt-12'
                  }`"
                >
                  <div
                    v-for="(item, index) in creatorList"
                    :key="item.name + '_mock_image_topic'"
                  >
                    <img
                      v-if="item.name == topicForm.creator"
                      v-lazy="item.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="item.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <img
                      v-else-if="
                        user.name == item.name &&
                        topicForm.creator == '' &&
                        user.pic
                      "
                      v-lazy="user.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="user.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div
                      v-else-if="topicForm.creator == '' && index == 1"
                      class="image image-profile-16 flex-mid mr-6"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <div class="text-in-image text-in-image-16 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    {{ $t("happilyVillage.By") }}
                    <span class="fw-700 fc-404243"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      topicForm.creator
                    }}</span>
                  </div>
                </div>
                <div v-if="mainPreview">
                  <div
                    :class="{
                      'preview-overflow': topicForm.fileList.length > 1,
                    }"
                    class="rm-scrollbar flex-center"
                  >
                    <div
                      v-for="(file, index) in topicForm.fileList"
                      :key="'image' + index"
                    >
                      <div v-if="checkedImageFile(fileExtension(file.name))">
                        <img
                          v-if="topicForm.fileList.length == 1"
                          class="image-preview image-preview-one"
                          :src="file.url"
                          :alt="file.name"
                        />
                        <img
                          v-else
                          class="image-preview image-preview-many"
                          :src="file.url"
                          :alt="file.name"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(file, index) in topicForm.fileList"
                    :key="'file' + index"
                  >
                    <div
                      v-if="checkedImageFile(fileExtension(file.name))"
                    ></div>
                    <div class="loading-box mt-10 flex-center relative" v-else>
                      <div class="file flex-mid fc-A0A0A0">
                        {{ fileExtension(file.name) }}
                      </div>
                      <div class="ml-16 ellipsis name">{{ file.name }}</div>
                      <div class="remove cursor-pointer flex-mid">
                        <img
                          :src="$utils('icons', 'open_in_new_gray_24px@2x')"
                          style="height: 20px; width: 20px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <div class="hv-compose-head">
              <div class="qd-eyebrow">Town Hall</div>
              <div class="hv-compose-title-row">
                <div class="hv-dialog-title">{{ editTopicStatus ? 'Edit topic' : 'New topic' }}</div>
                <span class="qd-type-pill th-type-topic">Topic</span>
              </div>
            </div>
            <form id="topicModalTopic" @submit.prevent="submitTopic">
              <div class="title" style="margin-top: 0px">
                {{ $t("happilyVillage.Topic_Creator") }}
              </div>
              <div class="relative">
                <el-select
                  v-model="topicForm.creator"
                  :placeholder="$t('happilyVillage.Select_Creator')"
                  class="creator-profile"
                  :class="[ blurMode ?  'blurelement': '' ]"
                >
                  <el-option
                    v-for="item in creatorList"
                    :key="item.name"
                    :label="item.name"
                    style="height: 42px"
                    :value="item.name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    <div class="flex-center my-4">
                      <div v-if="item.name != user.name">
                        <img
                          class="image-skeleton image-profile-32 mr-16"
                          :src="item.pic"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                      </div>
                      <div v-else>
                        <div v-if="user.pic">
                          <img
                            v-lazy="user.pic"
                            :key="user.pic"
                            class="
                              image-skeleton image-profile-32
                              flex-mid
                              mr-12
                            "
                            :class="[ blurMode ?  'blurelement': '' ]"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: user.firstname,
                                lastName: user.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="fs-18 fc-2D2E36">{{ item.name }}</div>
                    </div>
                  </el-option>
                </el-select>
                <div class="profiel-selected">
                  <div v-if="topicForm.creator == user.name">
                    <div v-if="user.pic">
                      <img
                        class="image-skeleton image-profile-32"
                        :src="user.pic"
                        alt=""
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                    </div>
                    <div v-else class="image image-profile-32 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-32 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in creatorList"
                    :key="item.name + '_showing_imge'"
                  >
                    <div
                      v-if="
                        item.name == topicForm.creator &&
                        topicForm.creator != user.name
                      "
                    >
                      <img
                        class="image-skeleton image-profile-32"
                        :src="item.pic"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Share_with") }}</div>
              <!-- <el-tooltip
                class="header-table-tooltip"
                placement="top"
                effect="light"
              > -->
              <!-- <div slot="content">
                  {{ $t("happilyVillage.Huddle_selection_is") }}
                  <br />{{ $t("happilyVillage.Coming_soon_to") }}
                </div> -->
              <el-cascader
                class="defaulttags"
                v-model="huddleTag"
                :placeholder="$t('happilyVillage.Team_or_Name')"
                :options="huddleTagData"
                :props="{ multiple: true }"
                style="width: 100%"
                :collapse-tags="huddleTag ? huddleTag.length > 8 : huddleTag"
                :debounce="500"
                :filter-method="filterToFunction"
                filterable
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-cascader>
              <div v-if="isProgramOnlySelected" class="program-only-hint">
                <span class="program-only-hint-icon"><i class="el-icon-lock"/></span>
                <div class="program-only-hint-copy">
                  <div class="program-only-hint-title">Program only</div>
                  <div class="program-only-hint-sub">
                    Hidden from Town Hall. Surfaces only to people enrolled in a Learning Program that uses this topic. Visibility scope, not encryption.
                  </div>
                </div>
              </div>
              <!-- </el-tooltip> -->
              <div class="title">{{ $t("happilyVillage.Title_of_Topic") }}</div>
              <el-input
                :placeholder="$t('happilyVillage.Short_but_descriptive')"
                v-model="topicForm.title"
                class="name"
                :class="{ 'validate-input': validateTopicForm.title }"
              ></el-input>
              <div v-if="validateTopicForm.title" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Name") }}
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Description") }}</div>
              <MarkdownEditor
                v-model="topicForm.description"
                :placeholder="$t('happilyVillage.A_sentence_or_two')"
                :has-error="validateTopicForm.description"
                :autosize="{ minRows: 8, maxRows: 12 }"
              />
              <div
                v-if="validateTopicForm.description"
                class="validate-worming"
              >
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Description") }}
                </div>
              </div>
              <div class="flex mt-32 mb-24">
                <div class="relative switch-contrainer">
                  <input
                    type="checkbox"
                    id="checkbox"
                    class="input-checkbox"
                    v-model="topicForm.commentEnabled"
                  />
                  <label for="checkbox" class="lable-checkbox">{{
                    topicForm.commentEnabled
                  }}</label>
                </div>
                <div class="hv-toggle-label">
                  {{ $t("happilyVillage.Comments_enabled") }}
                </div>
              </div>
              <el-upload
                class="upload-demo"
                action="no-Api"
                list-type="picture-card"
                :on-change="handleChange"
                :auto-upload="false"
                :show-file-list="false"
              >
                <el-button
                  slot="trigger"
                  class="btn-gray-outline"
                  icon="el-icon-plus"
                  >{{ $t("happilyVillage.UPLOAD_MEDIA") }}</el-button
                >
              </el-upload>
              <div
                v-for="(file, index) in topicForm.fileList"
                :key="index"
                class="loading-box mt-10 flex-center relative"
              >
                <img
                  v-if="checkedImageFile(fileExtension(file.name))"
                  class="file"
                  style="object-fit: cover"
                  :src="file.url"
                  :alt="file.name"
                />
                <div v-else class="file flex-mid fc-A0A0A0">
                  {{ fileExtension(file.name) }}
                </div>
                <div class="ml-16 ellipsis name">{{ file.name }}</div>
                <div
                  @click.passive="removeFileInList(file.uid)"
                  class="remove cursor-pointer flex-mid"
                >
                  <i class="el-icon-delete-solid"></i>
                </div>
              </div>
              <div v-if="!editTopicStatus" class="th-schedule mt-16">
                <el-radio-group v-model="topicPublishMode" size="small" @change="onTopicPublishModeChange">
                  <el-radio-button label="now">Publish now</el-radio-button>
                  <el-radio-button label="schedule">Schedule for later</el-radio-button>
                </el-radio-group>
                <div v-if="topicPublishMode === 'schedule'" class="th-schedule-body mt-12">
                  <div class="th-when-label">When should this publish?</div>
                  <div class="th-presets">
                    <button
                      v-for="opt in schedulePresetOptions"
                      :key="opt.key"
                      type="button"
                      class="th-preset"
                      :class="{ active: topicScheduleChoice === opt.key }"
                      @click="selectSchedulePreset(opt.key)"
                    >{{ opt.label }}</button>
                  </div>
                  <el-date-picker
                    v-if="topicScheduleChoice === 'custom'"
                    v-model="topicPublishAt"
                    type="datetime"
                    class="th-custom-picker mt-12"
                    placeholder="Pick a date and time"
                    format="MMM d, yyyy h:mm A"
                    default-time="09:00:00"
                    :picker-options="topicSchedulePickerOptions"
                  ></el-date-picker>
                  <div v-if="scheduleResolvedLabel" class="th-when-resolved">
                    <i class="el-icon-time"></i>
                    <span>Publishes {{ scheduleResolvedLabel }}</span>
                  </div>
                  <div v-if="topicForm.fileList && topicForm.fileList.length" class="th-schedule-note warn mt-8">
                    Scheduling does not support attachments yet. Remove the file(s) to schedule.
                  </div>
                  <div v-else class="th-schedule-note mt-8">
                    Saved as scheduled and visible to admins now. Automatic publishing rolls out soon.
                  </div>
                </div>
              </div>
              <div class="hv-dialog-footer">
                <el-button @click="addTopicModal = false">{{ $t("global.Cancel") }}</el-button>
                <el-button
                  v-if="editTopicStatus"
                  type="primary"
                  @click.prevent="editTopic"
                >
                  {{ $t("happilyVillage.Save_Changes") }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  @click.prevent="submitTopic"
                >
                  {{ $t("happilyVillage.CREATE_TOPIC") }}
                </el-button>
                <!-- <el-button
                  class="btn-cancel bigger"
                  @click="saveDraftTopicForm"
                >SAVE AS DRAFT</el-button>-->
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="checklist-modal">
      <el-dialog :visible.sync="addChecklistModal" width="930px">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="aq-preview-eyebrow">{{ $t("happilyVillage.Preview_on_Mobile") }}</div>
            <div class="body">
              <div
                v-if="!$utils('watchingTrim', checklistForm.title)"
                class="bg-skeleton height-32"
              ></div>
              <div v-else class="fc-404243 fs-18 fw-900 word-break">
                {{ checklistForm.title.trim() }}
              </div>
              <div class="fc-6C6C6C fs-12">
                <div
                  class="flex mb-24"
                  :class="`${
                    !$utils('watchingTrim', checklistForm.title)
                      ? 'mt-24'
                      : 'mt-12'
                  }`"
                >
                  <div
                    v-for="(item, index) in creatorList"
                    :key="item.name + '_mock_image_checklistForm'"
                  >
                    <img
                      v-if="item.name == checklistForm.creator"
                      v-lazy="item.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="item.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <img
                      v-else-if="
                        user.name == item.name &&
                        checklistForm.creator == '' &&
                        user.pic &&
                        index == 1
                      "
                      v-lazy="user.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="user.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div
                      v-else-if="checklistForm.creator == '' && index == 1"
                      class="image image-profile-16 flex-mid mr-6"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <div class="text-in-image text-in-image-16 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    {{ $t("happilyVillage.by") }}
                    <span class="fw-700 fc-404243"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      checklistForm.creator
                    }}</span>
                  </div>
                </div>
                <!-- Due-date pill: only when admin set a date. Mirrors
                     the RN ChecklistDueDatePill (neutral resting state). -->
                <div
                  v-if="checklistForm.dueDate"
                  class="ck-preview-due-pill mb-12"
                >
                  <i class="el-icon-time"></i>
                  Due {{ formatChecklistDueDate(checklistForm.dueDate) }}
                </div>
                <!-- Checklist description: shown when admin entered one,
                     placed under "by Author" so it reads like the RN view. -->
                <div
                  v-if="checklistForm.description && checklistForm.description.trim()"
                  class="ck-preview-desc mb-16"
                >
                  {{ checklistForm.description.trim() }}
                </div>
                <div
                  v-for="(data, index) in checklistForm.checklists"
                  :key="data._key || ('preview_list_' + index)"
                >
                  <div
                    class="preview-checklist mt-24"
                    v-if="!$utils('watchingTrim', data.label)"
                  >
                    <div class="card flex-center">
                      <div class="checkbox">&nbsp;</div>
                      <div class="list-label"></div>
                      <div class="arrow"></div>
                    </div>
                    <div class="shadow-inner"></div>
                  </div>
                  <div v-else class="preview-checklist real mt-24">
                    <div class="card flex-center">
                      <div class="checkbox">&nbsp;</div>
                      <div class="list-label ellipsis">
                        {{ data.label }}
                        <span
                          v-if="data.type === 'acknowledge'"
                          class="ck-preview-type-badge is-ack"
                          :title="$t('happilyVillage.Item_type_acknowledge')"
                        >ACK</span>
                        <span
                          v-else-if="data.type === 'link'"
                          class="ck-preview-type-badge is-link"
                          :title="$t('happilyVillage.Item_type_link')"
                        ><i class="el-icon-link"></i></span>
                        <span
                          v-if="data.required === false"
                          class="ck-preview-optional-tag"
                        >Optional</span>
                      </div>
                      <div class="arrow"></div>
                    </div>
                    <div class="shadow-inner"></div>
                  </div>
                  <div
                    v-if="
                      !$utils('watchingTrim', data.label) &&
                      index + 1 == checklistForm.checklists.length
                    "
                    class="bg-skeleton"
                    style="height: 15px; width: 55px"
                  >
                    &nbsp;
                  </div>
                  <div
                    v-else-if="index + 1 == checklistForm.checklists.length"
                    class="fc-44D1B1 fs-12 fw-700"
                  >
                    {{ $t("happilyVillage.Summary") }}
                  </div>
                </div>
                <!-- Tags chip row: only when admin added one or more. -->
                <div
                  v-if="checklistForm.tags && checklistForm.tags.length > 0"
                  class="ck-preview-tags mt-16"
                >
                  <span
                    v-for="tag in checklistForm.tags"
                    :key="tag"
                    class="ck-preview-tag"
                  >{{ tag }}</span>
                </div>
                <div class="flex mt-16 preview-wrroning">
                  <div>
                    <div class="fs-13 fw-700">
                      {{ $t("happilyVillage.You_are_completed") }} 0/{{
                        checklistRequiredCount
                      }}
                      {{ $t("happilyVillage.items") }}
                    </div>
                    <div class="fs-11 opa-05">
                      {{ $t("happilyVillage.Weekly_reminders_to") }}
                    </div>
                  </div>
                  <div class="fc-6C30CC flex-center fs-22 ml-auto">
                    <i class="el-icon-message-solid"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <div class="hv-compose-head">
              <div class="qd-eyebrow">Town Hall</div>
              <div class="hv-compose-title-row">
                <div class="hv-dialog-title">{{ editTopicStatus ? 'Edit checklist' : 'New checklist' }}</div>
                <span class="qd-type-pill th-type-checklist">Checklist</span>
              </div>
            </div>
            <form id="topicModalChecklist" @submit.prevent="createChecklist">
              <div class="title" style="margin-top: 0px">
                {{ $t("happilyVillage.Group_Checklist_Creator") }}
              </div>
              <div class="relative">
                <el-select
                  v-model="checklistForm.creator"
                  :placeholder="$t('happilyVillage.Select_Creator')"
                  class="creator-profile"
                  :class="[ blurMode ?  'blurelement': '' ]"
                >
                  <el-option
                    v-for="item in creatorList"
                    :key="item.name"
                    :label="item.name"
                    style="height: 42px"
                    :value="item.name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    <div class="flex-center my-4">
                      <div v-if="item.name != user.name">
                        <img
                          class="image-skeleton image-profile-32 mr-16"
                          :src="item.pic"
                          alt=""
                        />
                      </div>
                      <div v-else>
                        <div v-if="user.pic">
                          <img
                            v-lazy="user.pic"
                            :key="user.pic"
                            class="
                              image-skeleton image-profile-32
                              flex-mid
                              mr-12
                            "
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: user.firstname,
                                lastName: user.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="fs-18 fc-2D2E36">{{ item.name }}</div>
                    </div>
                  </el-option>
                </el-select>
                <div class="profiel-selected">
                  <div v-if="checklistForm.creator == user.name">
                    <div v-if="user.pic">
                      <img
                        class="image-skeleton image-profile-32"
                        :src="user.pic"
                        alt=""
                      />
                    </div>
                    <div v-else class="image image-profile-32 flex-mid mr-12">
                      <div class="text-in-image text-in-image-32 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in creatorList"
                    :key="item.name + '_showing_imge'"
                  >
                    <div
                      v-if="
                        item.name == checklistForm.creator &&
                        checklistForm.creator != user.name
                      "
                    >
                      <img
                        class="image-skeleton image-profile-32"
                        :src="item.pic"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Share_with") }}</div>
              <!-- <el-tooltip
                class="header-table-tooltip"
                placement="top"
                effect="light"
              >
                <div slot="content">
                  {{ $t("happilyVillage.Huddle_selection_is") }}
                  <br />{{ $t("happilyVillage.Coming_soon_to") }}
                </div> -->
              <el-cascader
                class="defaulttags"
                v-model="huddleTag"
                :placeholder="$t('happilyVillage.Team_or_Name')"
                :options="huddleTagData"
                :props="{ multiple: true }"
                style="width: 100%"
                :collapse-tags="huddleTag ? huddleTag.length > 8 : huddleTag"
                :filter-method="filterToFunction"
                filterable
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-cascader>
              <div v-if="isProgramOnlySelected" class="program-only-hint">
                <span class="program-only-hint-icon"><i class="el-icon-lock"/></span>
                <div class="program-only-hint-copy">
                  <div class="program-only-hint-title">Program only</div>
                  <div class="program-only-hint-sub">
                    Hidden from Town Hall. Surfaces only to people enrolled in a Learning Program that uses this checklist. Visibility scope, not encryption.
                  </div>
                </div>
              </div>
              <!-- </el-tooltip> -->
              <div class="title">
                {{ $t("happilyVillage.Title_of_Checklist") }}
              </div>
              <el-input
                :placeholder="$t('happilyVillage.Short_but_descriptive')"
                v-model="checklistForm.title"
                class="name"
                :class="{ 'validate-input': validateChecklistForm.title }"
              ></el-input>
              <div v-if="validateChecklistForm.title" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_title") }}
                </div>
              </div>
              <div class="title">
                {{ $t("happilyVillage.Description_of_Checklist") }}
              </div>
              <el-input
                type="textarea"
                :rows="2"
                v-model="checklistForm.description"
                :placeholder="$t('happilyVillage.A_sentence_or_two_about')"
              ></el-input>
              <div
                v-for="(input, index) in checklistForm.checklists"
                :key="input._key"
                class="ck-item-row"
              >
                <div class="title">
                  {{ $t("happilyVillage.Checklist_Item") }} {{ index + 1 }}
                </div>
                <el-input
                  :placeholder="$t('happilyVillage.Item_label')"
                  v-model="input.label"
                  class="name ck-item-label"
                ></el-input>
                <div class="ck-item-controls">
                  <el-select
                    v-model="input.type"
                    class="ck-item-type"
                    :placeholder="$t('happilyVillage.Checklist_item_type')"
                  >
                    <el-option :value="'simple'" :label="$t('happilyVillage.Item_type_simple')" />
                    <el-option :value="'acknowledge'" :label="$t('happilyVillage.Item_type_acknowledge')" />
                    <el-option :value="'link'" :label="$t('happilyVillage.Item_type_link')" />
                  </el-select>
                  <el-checkbox v-model="input.required" class="ck-item-required">
                    {{ $t("happilyVillage.Item_required") }}
                  </el-checkbox>
                  <button
                    v-if="checklistForm.checklists.length > 1"
                    type="button"
                    class="ck-item-remove"
                    @click="removeChecklistItem(index)"
                    :aria-label="'Remove item ' + (index + 1)"
                  >
                    <i class="el-icon-remove-outline"></i>
                  </button>
                </div>
                <el-input
                  v-if="input.type === 'acknowledge'"
                  type="textarea"
                  :rows="2"
                  v-model="input.description"
                  :placeholder="$t('happilyVillage.Acknowledge_what')"
                  class="mt-8"
                ></el-input>
                <el-input
                  v-if="input.type === 'link'"
                  v-model="input.link"
                  :placeholder="$t('happilyVillage.Link_placeholder')"
                  class="mt-8"
                ></el-input>
              </div>
              <div @click="addMoreList" class="button-outline flex-mid mt-24">
                <i class="mr-16 el-icon-plus"></i>
                {{ $t("happilyVillage.ADD_OPTION") }}
              </div>
              <div class="title mt-24">
                {{ $t("happilyVillage.Due_date") }}
              </div>
              <el-date-picker
                v-model="checklistForm.dueDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('happilyVillage.Due_date')"
                style="width: 100%"
              ></el-date-picker>
              <div v-if="checklistForm.dueDate" class="ck-reminder-relative mt-12">
                <el-checkbox-group v-model="checklistForm.reminderRelative">
                  <el-checkbox label="T-7">{{ $t("happilyVillage.Remind_7_days_before") }}</el-checkbox>
                  <el-checkbox label="T-1">{{ $t("happilyVillage.Remind_1_day_before") }}</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="title mt-24">{{ $t("happilyVillage.Tags") }}</div>
              <el-select
                v-model="checklistForm.tags"
                multiple
                filterable
                allow-create
                default-first-option
                :placeholder="$t('happilyVillage.Add_tag')"
                style="width: 100%"
              ></el-select>
              <div class="flex mt-32 mb-16">
                <div
                  class="relative switch-contrainer"
                  :class="{
                    'border-blue': checklistForm.showRespondentsResults,
                  }"
                >
                  <input
                    type="checkbox"
                    id="showRespondentsResults"
                    class="input-checkbox"
                    v-model="checklistForm.showRespondentsResults"
                  />
                  <label for="showRespondentsResults" class="lable-checkbox">{{
                    checklistForm.showRespondentsResults
                  }}</label>
                </div>
                <div class="hv-toggle-label">
                  {{ $t("happilyVillage.Show_respondents_in_results") }}
                </div>
              </div>
              <div class="flex my-16">
                <div class="relative switch-contrainer">
                  <input
                    type="checkbox"
                    id="commentEnabled"
                    class="input-checkbox"
                    v-model="checklistForm.commentEnabled"
                  />
                  <label for="commentEnabled" class="lable-checkbox">{{
                    checklistForm.commentEnabled
                  }}</label>
                </div>
                <div class="hv-toggle-label">
                  {{ $t("happilyVillage.Comments_enabled") }}
                </div>
              </div>
              <div class="flex my-16">
                <div class="relative switch-contrainer">
                  <input
                    type="checkbox"
                    id="weeklyReminders"
                    class="input-checkbox"
                    v-model="checklistForm.weeklyReminders"
                  />
                  <label for="weeklyReminders" class="lable-checkbox">{{
                    checklistForm.weeklyReminders
                  }}</label>
                </div>
                <div class="hv-toggle-label">
                  {{ $t("happilyVillage.Weekly_Reminders_off") }}
                </div>
              </div>
              <div
                :class="`set-weekly-reminders ${
                  checklistForm.weeklyReminders ? 'on' : ''
                }`"
              >
                {{ $t("happilyVillage.Every_week_on") }}
                <span>
                  <el-dropdown @command="setDayReimind">
                    <span class="el-dropdown-link fc-6C30CC">
                      {{ checklistForm.weeklyCofig.day }}
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      v-if="checklistForm.weeklyReminders"
                    >
                      <el-dropdown-item
                        v-for="value in dayDropdownValue"
                        :key="value + '_day'"
                        :command="value"
                        >{{ value }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                {{ $t("happilyVillage.at") }}
                <span>
                  <el-dropdown @command="setTimeReimind">
                    <span class="el-dropdown-link fc-6C30CC">
                      {{ checklistForm.weeklyCofig.time }}
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      v-if="checklistForm.weeklyReminders"
                    >
                      <el-dropdown-item
                        v-for="(value, index) in timeDropdownValue"
                        :key="index + '_time'"
                        :command="value"
                        >{{ value }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown> </span
                >, {{ $t("happilyVillage.if_checklist_is") }}
              </div>
              <div class="hv-dialog-footer">
                <el-button @click="addChecklistModal = false">{{ $t("global.Cancel") }}</el-button>
                <el-button
                  v-if="editTopicStatus"
                  type="primary"
                  @click.prevent="editChecklist"
                >
                  {{ $t("happilyVillage.Save_Changes") }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  @click.prevent="createChecklist"
                  >{{ $t("happilyVillage.CREATE_CHECKLIST") }}</el-button
                >
                <!-- <el-button
                  class="btn-cancel bigger"
                  style="padding-top: 12px"
                  @click.prevent="draftChecklist"
                  >SAVE AS DRAFT</el-button
                > -->
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="poll-modal">
      <el-dialog :visible.sync="addPollModal" width="930px">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="aq-preview-eyebrow">{{ $t("happilyVillage.Preview_on_Mobile") }}</div>
            <div class="body">
              <div
                v-if="!$utils('watchingTrim', pollForm.title)"
                class="bg-skeleton height-32"
              ></div>
              <div v-else class="fc-404243 fs-18 fw-900 word-break">
                {{ pollForm.title.trim() }}
              </div>
              
              <div v-if="pollDescriptionStripped" class="fc-767676 fs-14 fw-400 word-break">
                <MarkdownView :source="pollForm.description" />
              </div>

              <div class="fc-6C6C6C fs-12">
                <div
                  class="flex mb-24"
                  :class="`${
                    !$utils('watchingTrim', pollForm.title) ? 'mt-24' : 'mt-12'
                  }`"
                >
                  <div
                    v-for="(item, index) in creatorList"
                    :key="item.name + '_mock_image_pollForm'"
                  >
                    <img
                      v-if="item.name == pollForm.creator"
                      v-lazy="item.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="item.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <img
                      v-else-if="
                        user.name == item.name &&
                        pollForm.creator == '' &&
                        user.pic &&
                        index == 1
                      "
                      v-lazy="user.pic"
                      class="image-skeleton image-profile-16 mr-6"
                      :src="user.pic"
                      alt=""
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div
                      v-else-if="pollForm.creator == '' && index == 1"
                      class="image image-profile-16 flex-mid mr-6"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <div class="text-in-image text-in-image-16 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    {{ $t("happilyVillage.by") }}
                    <span class="fw-700 fc-404243"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ pollForm.creator }}</span>
                  </div>
                </div>
                <div
                  v-for="(data, index) in pollForm.polls"
                  :key="data.poll + 'preview_list_2_' + index"
                >
                  <div
                    class="preview-poll mt-24"
                    v-if="!$utils('watchingTrim', data.poll)"
                  >
                    <div class="poll-card flex-mid" style="margin-top: 19px">
                      {{ data.poll }}
                    </div>
                    <div></div>
                  </div>
                  <div v-else class="preview-poll real mt-24">
                    <div class="shadow"></div>
                    <div class="poll-card flex-mid">
                      <div class="ellipsis px-20">{{ data.poll }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <div class="hv-compose-head">
              <div class="qd-eyebrow">Town Hall</div>
              <div class="hv-compose-title-row">
                <div class="hv-dialog-title">{{ editTopicStatus ? 'Edit poll' : 'New poll' }}</div>
                <span class="qd-type-pill th-type-poll">Poll</span>
              </div>
            </div>
            <form id="topicModalPoll" @submit.prevent="createPoll">
              <div class="title" style="margin-top: 0px">
                {{ $t("happilyVillage.Poll_Creator") }}
              </div>
              <div class="relative">
                <el-select
                  v-model="pollForm.creator"
                  :placeholder="$t('happilyVillage.Select_Creator')"
                  class="creator-profile"
                  :class="[ blurMode ?  'blurelement': '' ]"
                >
                  <el-option
                    v-for="item in creatorList"
                    :key="item.name"
                    :label="item.name"
                    style="height: 42px"
                    :value="item.name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    <div class="flex-center my-4">
                      <div v-if="item.name != user.name">
                        <img
                          class="image-skeleton image-profile-32 mr-16"
                          :src="item.pic"
                          alt=""
                        />
                      </div>
                      <div v-else>
                        <div v-if="user.pic">
                          <img
                            v-lazy="user.pic"
                            :key="user.pic"
                            class="
                              image-skeleton image-profile-32
                              flex-mid
                              mr-12
                            "
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: user.firstname,
                                lastName: user.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="fs-18 fc-2D2E36">{{ item.name }}</div>
                    </div>
                  </el-option>
                </el-select>
                <div class="profiel-selected">
                  <div v-if="pollForm.creator == user.name">
                    <div v-if="user.pic">
                      <img
                        class="image-skeleton image-profile-32"
                        :src="user.pic"
                        alt=""
                      />
                    </div>
                    <div v-else class="image image-profile-32 flex-mid mr-12">
                      <div class="text-in-image text-in-image-32 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: user.firstname,
                            lastName: user.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in creatorList"
                    :key="item.name + '_showing_imge'"
                  >
                    <div
                      v-if="
                        item.name == pollForm.creator &&
                        pollForm.creator != user.name
                      "
                    >
                      <img
                        class="image-skeleton image-profile-32"
                        :src="item.pic"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Share_with") }}</div>
              <!-- <el-tooltip
                class="header-table-tooltip"
                placement="top"
                effect="light"
              >
                <div slot="content">
                  {{ $t("happilyVillage.Huddle_selection_is") }}
                  <br />{{ $t("happilyVillage.Coming_soon_to") }}
                </div> -->
              <el-cascader
                class="defaulttags"
                v-model="huddleTag"
                :placeholder="$t('happilyVillage.Team_or_Name')"
                :options="huddleTagData"
                :props="{ multiple: true }"
                style="width: 100%"
                :collapse-tags="huddleTag ? huddleTag.length > 8 : huddleTag"
                :filter-method="filterToFunction"
                filterable
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-cascader>
              <div v-if="isProgramOnlySelected" class="program-only-hint">
                <span class="program-only-hint-icon"><i class="el-icon-lock"/></span>
                <div class="program-only-hint-copy">
                  <div class="program-only-hint-title">Program only</div>
                  <div class="program-only-hint-sub">
                    Hidden from Town Hall. Surfaces only to people enrolled in a Learning Program that uses this poll. Visibility scope, not encryption.
                  </div>
                </div>
              </div>
              <!-- </el-tooltip> -->
              <div class="title">{{ $t("happilyVillage.Title_of_Poll") }}</div>
              <el-input
                :placeholder="$t('happilyVillage.Short_but_descriptive')"
                v-model="pollForm.title"
                class="name"
                :class="{ 'validate-input': validatePollForm.title }"
              ></el-input>
              <div v-if="validatePollForm.title" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_title") }}
                </div>
              </div>




              <div class="title">{{ $t("happilyVillage.Caption") }}</div>
              <MarkdownEditor
                v-model="pollForm.description"
                :placeholder="$t('happilyVillage.A_sentence_or_two_poll')"
                :has-error="validatePollForm.description"
              />
              <div v-if="validatePollForm.description " class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_title") }}
                </div>
              </div>




              <div
                v-for="(input, index) in pollForm.polls"
                :key="index + '_checklist'"
              >
                <div class="title">{{ $t("happilyVillage.Option") }} {{ index + 1 }}</div>
                <div class="flex-center">
                  <el-input
                    :placeholder="$t('happilyVillage.Option_label')"
                    v-model="input.poll"
                    class="name"
                  ></el-input>
                  <div
                    v-if="index + 1 == pollForm.polls.length && index > 1"
                    class="relative"
                  >
                    <div
                      v-if="input.statusNotEdit"
                      class="button-remove-list fs-32"
                      @click="pollForm.polls.splice(-1)"
                    >
                      <i class="el-icon-remove-outline"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div @click="addMorePoll" class="button-outline flex-mid mt-24">
                <i class="mr-16 el-icon-plus"></i>
                {{ $t("happilyVillage.ADD_OPTION") }}
              </div>
              <div class="flex my-16">
                <div class="relative switch-contrainer">
                  <input
                    type="checkbox"
                    id="commentEnabled"
                    class="input-checkbox"
                    v-model="pollForm.commentEnabled"
                  />
                  <label for="commentEnabled" class="lable-checkbox">{{
                    pollForm.commentEnabled
                  }}</label>
                </div>
                <div class="hv-toggle-label">
                  {{ $t("happilyVillage.Comments_enabled") }}
                </div>
              </div>
              <div class="hv-dialog-footer">
                <el-button @click="addPollModal = false">{{ $t("global.Cancel") }}</el-button>
                <el-button
                  v-if="editTopicStatus"
                  type="primary"
                  @click.prevent="editPoll"
                >
                  {{ $t("happilyVillage.Save_Changes") }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  @click.prevent="createPoll"
                  >{{ $t("happilyVillage.CREATE_POLL") }}</el-button
                >
                <!-- <el-button
                  class="btn-cancel bigger"
                  style="padding-top: 14px"
                  @click.prevent="draftChecklist"
                  >SAVE AS DRAFT</el-button
                > -->
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="comments-modal">
      <el-dialog
        :visible.sync="commentModal"
        width="930px"
        @close="closeCommentModal"
      >
        <div class="grid-2-sesstion grid-2-detail">
          <div class="grid-left-no thin-scrollbar p-40" style="height: 600px">
            <div class="fc-404243 fw-900 fs-18">{{ commentDetail.title }}</div>
            <div class="fc-767676 fw-400 fs-14 mt-8 mb-12 word-break" style="min-height: 40px">
              <MarkdownView v-if="isMarkdown(commentDetail)" :source="commentDetail.description_md" />
              <div v-else class="pre-line">{{ commentDetail.description || commentDetail.title }}</div>
            </div>
            <div class="flex items-center mb-24">
              <template v-if="commentDetail.type === 'poll'">
                <span class="fc-767676 opa-05 fs-13">
                  {{ $utils("addCommasInNumber", commentDetail.members.reduce((sum, votes) => sum + votes, 0)) }} {{ $t("happilyVillage.votes") }} • 
                  {{ $utils("addCommasInNumber", commentDetail.commentsall) }} {{ commentDetail.commentsall === 1 ? $t("happilyVillage.comment") : $t("happilyVillage.comments") }}
                </span>
              </template>
              <template v-else>
                <span class="fc-767676 opa-05 fs-13">
                  {{ $utils("addCommasInNumber", commentDetail.commentsall) }} {{ commentDetail.commentsall === 1 ? $t("happilyVillage.comment") : $t("happilyVillage.comments") }}
                </span>
              </template>
            </div>
            <div class="flex mb-24 mt-12">
              <img
                v-if="commentDetail.creatorImageProfile"
                v-lazy="commentDetail.creatorImageProfile"
                class="image-skeleton image-profile-24 mr-6"
                :src="commentDetail.creatorImageProfile"
                alt=""
                :class="[ blurMode ?  'blurelement': '' ]"
              />
              <div v-else class="image image-profile-24 flex-mid mr-6"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div class="text-in-image text-in-image-24 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: commentDetail.firstname,
                      lastName: commentDetail.lastname,
                    })
                  }}
                </div>
              </div>
              <div class="mt-2">
                {{ $t("happilyVillage.by") }}
                <span class="fw-700"
                :class="[ blurMode ?  'blurelement': '' ]">{{ commentDetail.creator }}</span>
              </div>
            </div>
            <div v-if="commentDetail.type == 'poll'" class="flex items-center justify-end">
              <div @click="downloadExcel_Poll()" class="flex items-center" style="cursor: pointer;">
                <img
                  :src="$utils('icons', 'ic_xls_download')"
                  class="mr-2"
                />
                <span class="align-middle pl-6 fw-700" style="line-height: 32px;">{{ $t("happilyVillage.Download_Results") }}</span>
              </div>
            </div>
            
            <div
              v-for="(file, index) in commentDetail.fileList"
              :key="index"
              class="loading-box mt-10 flex-center relative"
            >
              <img
                v-if="checkedImageFile(fileExtension(file.name))"
                class="file"
                style="object-fit: cover"
                :src="file.url"
                :alt="file.name"
              />
              <div v-else class="file flex-mid fc-A0A0A0">
                {{ fileExtension(file.name) }}
              </div>
              <div class="ml-16 ellipsis name">{{ file.name }}</div>
              <div class="remove cursor-pointer flex-mid">
                <a :href="file.url" target="_blank" rel="noopener noreferrer">
                  <img
                    src="@/assets/images/happilyvillage/round-open_in_new-24px.png"
                    alt="open_in_new"
                    class="mr-8"
                  />
                </a>
              </div>
            </div>
            <div v-if="commentDetail.type == 'poll'" class="poll-results mt-24">
              <div
                v-for="(value, index) in commentDetail.options"
                :key="value.options"
                class="poll-row"
              >
                <div class="poll-row-label fc-4A4A4A">{{ value.options }}</div>
                <div class="poll-row-bar">
                  <div class="poll-row-track">
                    <div
                      class="poll-row-fill"
                      :style="{
                        width: getPollBarWidth(index) + '%',
                        backgroundColor: getPollBarColor(index),
                      }"
                    ></div>
                  </div>
                  <div class="poll-row-percent">{{ getPollPercent(index) }}%</div>
                </div>
              </div>
            </div>
            <div v-else-if="commentDetail.type == 'checklist'">
              <div
                v-for="(value, index) in commentDetail.options"
                :key="checklistResultKey(value, index)"
                class="preview-checklist real mt-24"
                style="cursor: no-drop"
              >
                <div class="card flex-center">
                  <div class="checkbox">&nbsp;</div>
                  <div class="list-label ellipsis">{{ value.options }}</div>
                  <div class="arrow"></div>
                </div>
                <div class="shadow-inner flex">
                  <div
                    class="show-score green"
                    :style="`width: ${value.green}%;`"
                  ></div>
                  <div
                    class="show-score red"
                    :style="`width: ${value.red}%;`"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right comment-contrainer">
            <div class="fc-404243 fw-900 fs-17">
              {{ $utils("addCommasInNumber", commentDetail.commentsall) }}
              {{
                commentDetail.commentsall == 1
                  ? $t("happilyVillage.comment")
                  : $t("happilyVillage.comments")
              }}
            </div>
            <div class="comment-card mt-12">
              <div class="comment-box thin-scrollbar">
                <div v-if="commentData.length == 0" class="no-comment opa-05">
                  {{ $t("happilyVillage.Be_the_first_to_comment") }}
                </div>
                <div v-else class="">
                  <div
                    v-for="(value, valueI) in commentData"
                    :key="value.mparent_id + value.likeorder + valueI"
                  >
                    <div class="comment flex">
                      <div class="content-comment">
                        <img
                          v-if="value.creatorImageProfile"
                          v-lazy="value.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="value.creatorImageProfile"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: value.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                              :class="[ blurMode ?  'blurelement': '' ]"
                                >{{ value.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(value.value)"
                              ></span>
                            </div>

                            <div v-if="value.image">
                              <img
                                v-lazy="value.image"
                                :alt="value.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(value)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                {{ $t("happilyVillage.Reply") }}
                              </div>
                              <div>
                                &nbsp;• {{ value.like }} {{ $t("happilyVillage.Likes") }}&nbsp;•
                                {{ prettyDate(value.createdate) }}
                              </div>
                              <div
                                class="flex-center"
                                v-if="value.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ value.giftcoin }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="value.liked === false"
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                    <div
                      v-for="(subValue, index) in value.subComment"
                      :key="
                        value.mparent_id +
                        subValue.likeorder +
                        valueI +
                        value.likeorder +
                        index
                      "
                      class="comment flex"
                    >
                      <div class="content-comment-sub">
                        <img
                          :src="$utils('icons', 'ic_reply_arrow_24px')"
                          alt="icons_ic_reply_arrow_24px"
                        />
                        <img
                          v-if="subValue.creatorImageProfile"
                          v-lazy="subValue.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="subValue.creatorImageProfile"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: subValue.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                              :class="[ blurMode ?  'blurelement': '' ]"
                                >{{ subValue.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(subValue.value)"
                              ></span>
                            </div>
                            <div v-if="subValue.image">
                              <img
                                v-lazy="subValue.image"
                                :alt="subValue.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(subValue)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                {{ $t("happilyVillage.Reply") }}
                              </div>
                              <div>
                                &nbsp;• {{ subValue.like }} {{ $t("happilyVillage.Likes") }}&nbsp;•
                                {{ prettyDate(subValue.createdate) }}
                              </div>
                              <div
                                class="flex-center"
                                v-if="subValue.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ subValue.giftcoin > 0 }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="subValue.liked == false"
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div id="comment_data_bottom"></div>
              </div>
              <div class="input-container flex-center">
                <img
                  v-if="userLogin.profilepic_small"
                  v-lazy="userLogin.profilepic_small"
                  class="image-skeleton image-profile-32 mr-12"
                  :src="userLogin.profilepic_small"
                  alt=""
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-32 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-32 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: userLogin.firstname,
                        lastName: user.lastname,
                      })
                    }}
                  </div>
                </div>
                <div
                  class="relative input-contain"
                  style="display: grid; grid-template-columns: auto 1fr"
                >
                  <div class="flex-center">
                    <div
                      v-if="replyCommentData.name"
                      class="reply-tag ml-6 flex-center"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <img
                        :src="$utils('icons', 'ic_reply_arrow_small_16px')"
                        alt="icons_ic_reply_arrow_small_16px"
                      />
                      {{ replyCommentData.name }}
                    </div>
                  </div>
                  <input
                    v-model="messageInput"
                    @keyup="searchMember(messageInput)"
                    class="input-box"
                    type="text"
                    :placeholder="
                      replyCommentData.name
                        ? $t('happilyVillage.Reply_here')
                        : $t('happilyVillage.Comment_here')
                    "
                  />
                  <div
                    class="mention-container thin-scrollbar"
                    :style="mentionsTopPosition(this.searchMemberArr.length)"
                    v-if="this.searchMemberArr.length > 0"
                  >
                    <div
                      class="memeber-box flex-center"
                      @click="mentionToText(mem)"
                      v-for="mem in this.searchMemberArr"
                      :key="mem.id + '_searching'"
                    >
                      <div>
                        <div>{{ mem.fullname }}</div>
                        <div class="opa-08 fs-10">{{ mem.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  v-if="replyCommentData.user && messageInput"
                  @click="submitReply"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else-if="replyCommentData.user"
                  @click="clearReplyData"
                  src="@/assets/images/happilyvillage/btn-reply-cancel.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else
                  @click="submitMessage"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <TownHallReelStudio
      v-if="reelsEnabled"
      v-model="reelStudioOpen"
      :reel="editingReel"
      :audience-options="huddleTagData"
      :tag-suggestions="townhallTags"
      :company-data="companyData"
      @saved="reelSaved"
      @published="reelPublished"
    />
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { buildHVBarOptions, buildHVBarDataset } from "./helpers/chart-defaults.js";
import moment from "moment";
import format from "date-fns/format";
import { globalfunc } from "../../globalfunc";
import {
  enforceProgramOnlyExclusivity,
  EVERYONE_KEY,
  PROGRAM_ONLY_KEY,
} from "../../store/huddle-helpers";
import {
  CHECKLIST_ITEM_TYPES,
  normalizeItems,
} from "../../store/checklist-item-helpers";
import MarkdownEditor from "../markdown/editor/MarkdownEditor.vue";
import MarkdownView from "../markdown/MarkdownView.vue";
import { isMarkdown, initialEditorValue, stripMarkdown } from "../markdown";
import { loadInboxPref, saveInboxPref } from "./town-hall/inbox-logic";
import firebase from "firebase/app";
import "firebase/firestore";
export default {
  name: "townHall",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
    MarkdownEditor,
    MarkdownView,
    TownHallInbox: () => import("./town-hall/TownHallInbox.vue"),
    TownHallReelOutbox: () => import("./town-hall/TownHallReelOutbox.vue"),
    TownHallReelStudio: () => import("./town-hall/TownHallReelStudio.vue"),
  },
  created() {
    this.loadReelsFeatureFlag();
    this.$store.dispatch("happilyvillageTownhall/getCreator", this.userLogin);
    this.$store.dispatch(
      "happilyvillageTownhall/getHouseAndTeam",
      this.userLogin
    );
    this.$store.dispatch("happilyvillageTownhall/getUser", this.userLogin);
    this.$store.dispatch("happilyvillageTownhall/getChildren", this.userLogin);
  },
  watch: {
    useInbox(val) {
      saveInboxPref(typeof window !== "undefined" ? window.localStorage : null, val);
    },
    townhall_graphmonth() {
      if (this.townHall_bar_chart) {
        this.townHall_bar_chart.destroy();
      }
      this.randerBarChartTownhall();
    },
    inputSearchTownhall(value) {
      this.typeingSearchTownhall(value);
    },
    huddleTag(newVal) {
      // Live UI feedback for the rule that buildHuddleSave enforces on
      // save: Program only and other huddle picks are mutually exclusive.
      const next = enforceProgramOnlyExclusivity(newVal);
      if (next) this.huddleTag = next;
    },
  },
  computed: {
    companyData() {
      return this.$store.getters["authen/companyData"] || {};
    },
    townhallTags() {
      return this.$store.getters["happilyvillageTownhall/townhallTags"] || { tags: {} };
    },
    topicSchedulePickerOptions() {
      return {
        disabledDate(d) {
          return d.getTime() < Date.now() - 86400000;
        },
      };
    },
    scheduleResolvedLabel() {
      if (this.topicPublishMode !== "schedule" || !this.topicPublishAt) return "";
      return moment(this.topicPublishAt).format("dddd, MMM D [at] h:mm A");
    },
    topicDescriptionStripped() {
      return stripMarkdown(this.topicForm.description || "").trim();
    },
    pollDescriptionStripped() {
      return stripMarkdown(this.pollForm.description || "").trim();
    },
    userLogin() {
      return this.$store.getters["authen/user"];
    },
    // Mirrors the RN ChecklistView count: only required items gate
    // completion, so the preview footer should match what members see.
    // Falls back to the full count when no items have a required flag
    // (legacy / empty form state) so the preview never shows 0/0.
    checklistRequiredCount() {
      const items = (this.checklistForm && this.checklistForm.checklists) || [];
      const required = items.filter((it) => it && it.required !== false).length;
      return required > 0 ? required : items.length;
    },
    allusers() {
      return this.$store.getters["happilyvillage/allusers"];
    },
    townHallShowing() {
      return this.$store.getters["happilyvillageTownhall/townHalls"];
    },
    townhall_graphmonth() {
      return this.$store.getters[
        "happilyvillageTownhall/townhall_graphmonth16"
      ];
    },
    townhall_all() {
      return this.$store.getters["happilyvillageTownhall/townhall_total16"];
    },
    creatorList() {
      return this.$store.getters["happilyvillageTownhall/creator"];
    },
    // inputSearchTownhall: {
    //   get() {
    //     return this.$store.getters[
    //       "happilyvillageTownhall/inputSearchTownhall"
    //     ];
    //   },
    //   set(value) {
    //     this.$store.commit("happilyvillageTownhall/setInputSearchTownhall", {
    //       keyword: value,
    //     });
    //   },
    // },
    townHallResults() {
      return this.$store.getters["happilyvillageTownhall/townHallResults"];
    },
    loadingTownHallTable() {
      return this.$store.getters["happilyvillageTownhall/loadingTownHallTable"];
    },
    mainPreview() {
      let statusSession =
        this.$utils("watchingTrim", this.topicForm.title) &&
        this.$utils("watchingTrim", this.topicForm.description);
      return statusSession || false;
    },
    adviser() {
      return this.$store.getters["happilyvillageTownhall/adviser"];
    },
    huddleTagData() {
      return this.$store.getters["happilyvillageTownhall/huddleTagData"];
    },
    commentData() {
      this.scrollToBottomComments();
      return this.$store.getters["happilyvillageTownhall/comment"];
    },
    commentId() {
      return this.$store.getters["happilyvillageTownhall/commentId"];
    },
    userAll() {
      return this.$store.getters["happilyvillageTownhall/userAll"];
    },
    member() {
      return this.$store.getters["happilyvillageTownhall/member"];
    },
    organization1level() {
      return this.$store.getters["happilyvillageTownhall/organization1level"];
    },
    membersPoll() {
      return this.$store.getters["happilyvillageTownhall/membersPoll"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    isProgramOnlySelected() {
      return (this.huddleTag || []).some((tag) => {
        const k = Array.isArray(tag) ? tag[0] : tag;
        return k === PROGRAM_ONLY_KEY;
      });
    },
  },
  data() {
    return {
      reelsEnabled: process.env.NODE_ENV !== "production",
      contentMode: "posts",
      reelStudioOpen: false,
      editingReel: null,
      // Remembered per-device so the beta opt-in survives reloads.
      useInbox: loadInboxPref(typeof window !== "undefined" ? window.localStorage : null),
      id: "",
      townHall: [],
      addTopicModal: false,
      commentModal: false,
      townhallId: "",
      replyCommentStatus: false,
      comment: {},
      inputSearchTownhall: "",
      commentDetail: {
        title: "",
        description: "",
        description_md: "",
        description_format: "",
        creator: "",
        firstname: "",
        lastname: "",
        creatorImageProfile: "",
        type: "",
        options: "",
        members: [],
        fileList: [
          // {
          //   name: "tset.pdf",
          // },
          // {
          //   name: "Happily Logo.JPG",
          //   url: "data:image/jpeg;base64,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",
          // },
        ],
        commentsall: 0,
      },
      addChecklistModal: false,
      downloadTownHallBar: false,
      loadingChartStatus: true,
      previewImage: [],
      editTopicStatus: false,
      editingDraft: false,
      currentPage: 1,
      user: {
        pic: null,
        firstname: "Firstname",
        lastname: "Lastname",
        name: "Firstname L",
      },

      // creatorList: [
      //   {
      //     pic: "Happiness",
      //     name: "Harry (Happiness)",
      //   },
      //   {
      //     pic: "Feedback",
      //     name: "Freddie (Feedback)",
      //   },
      //   {
      //     pic: "Wellness",
      //     name: "Will (Wellness)",
      //   },
      //   {
      //     pic: "Ambassadorship",
      //     name: "Amy (Ambassadorship)",
      //   },
      //   {
      //     pic: "Rel.Manager",
      //     name: "Max (Relationship with Manager)",
      //   },
      //   {
      //     pic: "Rel.Colleagues",
      //     name: "Ron and Reef (Relationship with Colleagues)",
      //   },
      //   {
      //     pic: "Satisfaction",
      //     name: "Sam (Satisfaction)",
      //   },
      //   {
      //     pic: "Recognition",
      //     name: "Rain (Recognition)",
      //   },
      //   {
      //     pic: "Introspection",
      //     name: "Iro (Introspection)",
      //   },
      //   {
      //     pic: "Company-Alignment",
      //     name: "Cole (Company Alignment)",
      //   },
      //   {
      //     pic: "Personal-Growth",
      //     name: "Pam (Personal Growth)",
      //   },
      // ],
      topicForm: {
        title: "",
        description: "",
        commentEnabled: true,
        media: null,
        fileList: [],
        arrFileOld: [],
        creator: "",
        pic: null,
      },
      validateTopicForm: {
        title: false,
        description: false,
      },
      topicPublishMode: "now",
      topicPublishAt: null,
      topicScheduleChoice: "tomorrow",
      schedulePresetOptions: [
        { key: "tomorrow", label: "Tomorrow" },
        { key: "monday", label: "Monday" },
        { key: "week", label: "In a week" },
        { key: "custom", label: "Custom" },
      ],

      checklistForm: {
        creator: "",
        title: "",
        description: "",
        checklists: [
          { _key: "ck_init_1", label: "", type: CHECKLIST_ITEM_TYPES.SIMPLE, required: true, description: "", link: "" },
          { _key: "ck_init_2", label: "", type: CHECKLIST_ITEM_TYPES.SIMPLE, required: true, description: "", link: "" },
        ],
        dueDate: "",
        reminderRelative: [],
        tags: [],
        members: [],
        showRespondentsResults: true,
        commentEnabled: true,
        weeklyReminders: true,
        weeklyCofig: {
          day: "Monday",
          time: "9:00 AM",
        },
      },
      validateChecklistForm: {
        title: false,
      },
      dayDropdownValue: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      timeDropdownValue: [
        "7 AM",
        "8 AM",
        "9 AM",
        "10 AM",
        "11 AM",
        "12 AM",
        "1 PM",
        "2 PM",
        "3 PM",
        "4 PM",
        "5 PM",
        "6 PM",
        "7 PM",
        "8 PM",
        "9 PM",
        "10 PM",
        "11 PM",
        "12 PM",
        "1 AM",
        "2 AM",
        "3 AM",
        "4 AM",
        "5 AM",
        "6 AM",
      ],
      addPollModal: false,
      pollForm: {
        creator: "",
        description:"",
        title: "",
        polls: [{ poll: "" }, { poll: "" }],
        commentEnabled: true,
      },
      validatePollForm: {
        title: false,
        description:false
      },
      huddleTag: [["everyone"]],
      statusUpdate: false,
      // huddleTagData: [
      //   {
      //     value: "everyone",
      //     label: "Everyone",
      //   },
      // ],
      messageInput: "",
      searchMemberArr: [],
      mention: [],
      // member: [
      //   {
      //     name: "AA",
      //     firstname: "Ali",
      //     fullname: "Ali Alies",
      //     email: "ali_a@email.com",
      //     id: "ali1B111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Beatriz",
      //     fullname: "Beatriz Beatroze",
      //     email: "beatriz_b@email.com",
      //     id: "beatriz1N111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Ceatriz",
      //     fullname: "Ceatriz Mit",
      //     email: "ceatriz_m@email.com",
      //     id: "beatrizM1111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Meatriz",
      //     fullname: "Meatriz Hrolla",
      //     email: "meatriz_h@email.com",
      //     id: "beatriz1111",
      //   },
      //   {
      //     name: "CT",
      //     firstname: "Charles",
      //     fullname: "Charles Prello",
      //     email: "charles_p@email.com",
      //     id: "charles1111",
      //   },
      //   {
      //     name: "DM",
      //     firstname: "Diya",
      //     fullname: "Diya Mania",
      //     email: "diya_m@email.com",
      //     id: "diya1111",
      //   },
      //   {
      //     name: "EP",
      //     firstname: "Eric",
      //     fullname: "Eric Poomchai",
      //     email: "eric_p@email.com",
      //     id: "aeric1111",
      //   },
      //   {
      //     name: "TG",
      //     firstname: "Tarin",
      //     fullname: "Tarin Gurin",
      //     email: "tarin@email.com",
      //     id: "aeric111tad231",
      //   },
      // ],
      replyCommentData: {
        company: "",
        createdate: "",
        likeorder: 0,
        mparent_id: "",
        name: "",
        type: "",
        user: "",
        value: "",
      },
    };
  },
  mounted() {
    if (this.townHall_bar_chart) {
      this.townHall_bar_chart.destroy();
    }
    this.randerBarChartTownhall();
    this.openProgramTownHallComposerFromRoute();
  },
  methods: {
    async loadReelsFeatureFlag() {
      if (process.env.NODE_ENV !== "production") return;
      try {
        const snapshot = await firebase.firestore().collection("feature_flags").doc("townhall_reels").get();
        const flag = snapshot.exists ? snapshot.data() : {};
        const company = (this.userLogin || {}).company;
        this.reelsEnabled = Boolean(flag.enabled || (Array.isArray(flag.enabled_companies) && flag.enabled_companies.includes(company)));
      } catch (error) {
        this.reelsEnabled = false;
        console.warn("Town Hall reels feature flag unavailable", error);
      }
    },
    closeCommentModal() {
      (this.commentDetail = {
        title: "",
        description: "",
        creator: "",
        firstname: "",
        lastname: "",
        creatorImageProfile: "",
        type: "",
        options: "",
        members: [],
        fileList: [],
        commentsall: 0,
      }),
        (this.commentModal = false);
      if (this.statusUpdate == true) {
        this.$store.commit("happilyvillageTownhall/setTownHallShowing", []);
        this.$store.commit(
          "happilyvillageTownhall/setLoadingTownhallTable",
          true
        );
        this.$store.dispatch("happilyvillageTownhall/getTownhall").then(() => {
          this.$store.dispatch(
            "happilyvillageTownhall/currentTopicsChange",
            this.currentPage
          );
        });
      }
    },
    prettyDate(datetime) {
      if (!datetime) return;

      const now = new Date();
      const target = new Date(datetime).toISOString().split("T")[0];
      var hours = Math.abs(new Date() - new Date(datetime)) / 36e5;
      now.setDate(now.getDate() - 1);
      const yesterday = now.toISOString().split("T")[0];

      // @see https://date-fns.org/v1.29.0/docs/format
      let result = format(datetime, "MMM D");
      const time = format(datetime, "h:mm A");
      if (hours < 1) {
        var diffMins = Math.round(
          ((Math.abs(new Date() - new Date(datetime)) % 86400000) % 3600000) /
            60000
        );
        result = diffMins + " minute ago";
      } else if (hours < 24) {
        result = Math.round(hours) + " hours ago";
      } else if (target == yesterday) {
        result = "Yesterday";
        result += ` at ${time}`;
      } else {
        result += ` at ${time}`;
      }
      return result;
    },
    likeOrUnlike(value) {
      this.$store.dispatch("happilyvillageTownhall/likeOrUnLike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.key;
      });
    },
    likeOrUnlike(value) {
      this.$store.dispatch("happilyvillageTownhall/likeOrUnLike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.key;
      });
      if (commentData.liked == true) {
        commentData.liked = false;
      } else {
        commentData.liked = true;
      }
    },
    replylikeOrUnlike(value) {
      this.$store.dispatch("happilyvillageTownhall/replylikeOrUnlike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.maprent_id2;
      });
      let subCommentData = _.find(commentData.subComment, function (o) {
        return o.key === value.key;
      });
      if (subCommentData.liked == true) {
        subCommentData.liked = false;
      } else {
        subCommentData.liked = true;
      }
    },
    replyComment(value) {
      if (value.maprent_id2) {
        let commentData = _.find(this.commentData, function (o) {
          return o.key === value.maprent_id2;
        });
        this.replyCommentData = JSON.parse(JSON.stringify(commentData));
      } else {
        this.replyCommentData = JSON.parse(JSON.stringify(value));
      }
    },
    clearReplyData() {
      this.replyCommentData.company = "";
      this.replyCommentData.createdate = "";
      this.replyCommentData.likeorder = 0;
      this.replyCommentData.mparent_id = "";
      this.replyCommentData.name = "";
      this.replyCommentData.type = "";
      this.replyCommentData.user = "";
      this.replyCommentData.value = "";
      this.mention = [];
    },
    searchMember(str) {
      // console.log("str",str)
      let regex = /\B@[a-z0-9_-]+/gi;
      let members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        const membersFilter = filterStr.match(regex);
        if (
          membersFilter &&
          membersFilter.length > 0 &&
          filterStr.search(membersFilter + " ") < 0
        ) {
          const searchName = membersFilter[membersFilter.length - 1];
          let filtered = _.filter(this.member, (item) => {
            return (
              item.fullname
                .toLowerCase()
                .indexOf(searchName.toLowerCase().slice(1, searchName.length)) >
              -1
            );
          });

          if (filtered.length < this.member.length) {
            this.searchMemberArr = filtered;
          } else {
            this.searchMemberArr = [];
          }
        } else {
          this.searchMemberArr = [];
        }
      } else {
        this.searchMemberArr = [];
      }
    },
    urlify(text) {
      let urlRegex =
        /(\b(https?|http?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, (url) => {
        return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
      });
    },
    checkUserAdded(str) {
      let text = str;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      for (let i = 0; i < this.mention.length; i++) {
        text = text.replace("@" + this.mention[i].firstname, "");
      }
      let mention = [];
      members.map((v) => {
        let _findmention = _.find(this.member, function (value) {
          return value.mention === v;
        });
        if (_findmention) {
          mention.push(_findmention);
        }
      });
      // this.mention = mention;
      return text;
    },
    mentionToText(value) {
      const str = this.messageInput;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        let membersFilter = filterStr.match(regex);
        if (membersFilter && membersFilter.length > 0) {
          this.messageInput = this.messageInput.replace(
            membersFilter[membersFilter.length - 1],
            "@" + value.firstname + " "
          );

          this.mention.push({ ...value, mention: "@" + value.firstname });
          this.searchMemberArr = [];
        }
      }
    },
    submitReply() {
      let key = this.replyCommentData.key;
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });

      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );
      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.townhallId,
        maprent_id2: this.replyCommentData.key,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        type: "townhall",
        user: this.userLogin.email,
        value: this.messageInput,
      };

      let commentData = _.find(this.commentData, function (o) {
        return o.key == key;
      });
      commentData.subComment.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageTownhall/replyComment", {
          townhallId: this.townhallId,
          comment: this.replyCommentData,
          message: this.messageInput,
          likeorder: likeorder,
          notifications: notifications,
        })
        .then(() => {
          this.messageInput = "";
          this.statusUpdate = true;
        });

      this.clearReplyData();
    },
    async submitMessage() {
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });
      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );

      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.townhallId,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        subComment: [],
        type: "townhall",
        user: this.userLogin.email,
        value: this.messageInput,
      };
      this.commentData.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageTownhall/comment", {
          townhallId: this.townhallId,
          message: this.messageInput,
          likeorder: likeorder,
          notifications: notifications,
        })
        .then(() => {
          let commentData = _.find(this.commentData, function (o) {
            return !o.key;
          });
          commentData.key = this.commentId;
          this.messageInput = "";
          this.statusUpdate = true;
        });
    },
    showCommentModal(value) {
      // console.log('Row data:', value);
      let options = [];
      let totalUser = 0;
      let userInTeam = _.groupBy(this.member, function (b) {
        return b.team;
      });
      if (value.delete == "huddles") {
        for (let i in value.huddles) {
          if (value.huddles[i].team) {
            if (this.organization1level[value.huddles[i].key]) {
              for (let teamId in this.organization1level[
                value.huddles[i].key
              ]) {
                if (userInTeam[teamId]) {
                  totalUser = totalUser + userInTeam[teamId].length;
                }
              }
            } else {
              totalUser =
                totalUser + ((userInTeam[value.huddles[i].key] || []).length);
            }
          } else if (value.huddles[i].house) {
            let huddlesUser = _.filter(this.member, function (currentObject) {
              return currentObject.house == value.huddles[i].key;
            });
            totalUser = totalUser + huddlesUser.length;
          }
        }
      } else {
        totalUser = this.member.length;
      }
      if (value.type == "checklist") {
        const checklistItems = normalizeItems(value.options || []);
        checklistItems.forEach((item, index) => {
          const green = this.percentOfTotal(
            (value.members && value.members[index]) || 0,
            totalUser
          );
          const red = this.percentOfTotal(value.read || 0, totalUser);
          options.push({
            key: this.checklistOptionKey(item, index),
            options: item.label,
            green: green,
            red: red,
            gray: 100,
          });
        });
      } else if (value.type == "poll") {
        const members = _.orderBy(
          value.members,
          [function (o) {
            return o;
          }],
          ["desc"]
        );
        const sumMembers = members.reduce((partialSum, a) => partialSum + a, 0);
        for (let v in value.options) {
          let green = this.percentOfTotal(value.members[v] || 0, sumMembers);
          let red = this.percentOfTotal(value.read || 0, totalUser);
          options.push({
            options: value.options[v],
            green: green,
            red: red,
            gray: 100,
          });
        }
        this.$store.dispatch("happilyvillageTownhall/getMembersPoll", { id: value.key });
      }
      this.commentDetail.options = options; //value.options
      this.commentDetail.members = value.members;
      this.commentDetail.title = value.title;
      this.commentDetail.commentsall = value.commentsall;
      this.commentDetail.type = value.type;
      this.commentDetail.description = value.description;
      this.commentDetail.description_md = value.description_md;
      this.commentDetail.description_format = value.description_format;
      this.commentDetail.creator = value.create_name;
      this.commentDetail.firstname = value.firstname;
      this.commentDetail.lastname = value.lastname;
      const createUser = value.create_user;
      const isCharacterPost =
        createUser === "happily_charracter" ||
        createUser === "happily_character" ||
        (typeof createUser === "string" &&
          createUser.toLowerCase().includes("happily")) ||
        !!(value.happily_user && value.happily_user !== "");
      if (isCharacterPost) {
        this.commentDetail.creatorImageProfile = value.happily_user || "";
        if (!value.firstname && !value.lastname && value.create_name) {
          const parts = String(value.create_name).trim().split(/\s+/);
          this.commentDetail.firstname = parts[0] || "";
          this.commentDetail.lastname = parts[1] || "";
        }
      } else if (this.userAll[createUser]) {
        const u = this.userAll[createUser];
        this.commentDetail.creatorImageProfile =
          u.profilepic_crop || u.profilepic_small || u.profilepic || "";
      } else {
        this.commentDetail.creatorImageProfile = "";
      }

      if (value.images && value.pdfimages) {
        this.commentDetail.fileList = [...value.images, ...value.pdfimages];
      } else if (value.images) {
        this.commentDetail.fileList = [...value.images];
      } else if (value.pdfimages) {
        this.commentDetail.fileList = [...value.pdfimages];
      }
      if (value.video && value.video.name) {
        let video = {
          name: value.video.name,
          url: value.video.url,
        };
        this.commentDetail.fileList.push(video);
      }
      this.$store
        .dispatch("happilyvillageTownhall/getComment", { id: value.key })
        .then(() => {
          this.townhallId = value.key;
          this.commentModal = true;
          this.scrollToBottomComments();
        });
    },
    randerBarChartTownhall() {
      var townHallBarchart = this.$refs.townHallBarchart;
      const months = [];
      const value = [];
      for (const x in this.townhall_graphmonth) {
        months.push(this.townhall_graphmonth[x].month);
        value.push(this.townhall_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      months.reverse();
      value.reverse();
      
      if (townHallBarchart) {
        this.loadingChartStatus = false;
        const townHallChartData = {
          labels: months,
          datasets: [
            {
              label: "Knowledge Sharing Interactions",
              data: value,
              ...buildHVBarDataset('townhall'),
            },
          ],
        };
        this.townHall_bar_chart = new Chart(
          townHallBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: townHallChartData,
            options: buildHVBarOptions('townhall'),
          }
        );
      }
    },
    exportTable(val) {
      console.log("Export excel file:", val); // TODO: Export excel file function!
      this.downloadTownHallBar = true;
      setTimeout(() => {
        this.downloadTownHallBar = false;
      }, 2000);
    },
    townHallTopicSort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("happilyvillageTownhall/townHallTopicSort", [
          column.property,
          order,
        ]);
      }
    },
    handleCurrentTopicsChange(val) {
      this.currentPage = val;
      this.$store.dispatch("happilyvillageTownhall/currentTopicsChange", val);
    },
    typeingSearchTownhall(value) {
      this.$store.dispatch("happilyvillageTownhall/searchTownHallsTownHall", {
        value: value,
        typingTimeout: this.variable.typingTimeout,
      });
    },
    submitTopic() {
      if (!this.editTopicStatus && this.topicPublishMode === "schedule") {
        return this.submitScheduledTopic();
      }
      this.validateName();
      this.validateDescription();
      let validateData =
        this.$utils("watchingTrim", this.topicForm.title) &&
        this.$utils("watchingTrim", this.topicForm.description);
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = _.clone(this.topicForm);
        this.$store
          .dispatch("happilyvillageTownhall/createTopic", {
            form: form,
            id: id,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.addTopicModal = false;
            this.cancelTownHallModal();
          });
        this.$message({
          type: "success",
          message: "New Topic has been created",
        });
      }
    },
    // Resolve a quick-schedule preset to a concrete Date. Business-day
    // presets land at 9:00 AM local — the most common, appropriate slot
    // for a company-wide announcement.
    presetDate(key) {
      const at9 = (m) => m.hour(9).minute(0).second(0).millisecond(0);
      if (key === "tomorrow") return at9(moment().add(1, "day")).toDate();
      if (key === "monday") {
        let m = at9(moment()).day(1);
        if (m.isSameOrBefore(moment())) m = m.add(7, "days");
        return m.toDate();
      }
      if (key === "week") return at9(moment().add(7, "days")).toDate();
      return null;
    },
    selectSchedulePreset(key) {
      this.topicScheduleChoice = key;
      if (key === "custom") {
        // Seed the custom picker with a sensible 9 AM starting point.
        if (!this.topicPublishAt) this.topicPublishAt = this.presetDate("tomorrow");
      } else {
        this.topicPublishAt = this.presetDate(key);
      }
    },
    onTopicPublishModeChange(mode) {
      if (mode === "schedule") {
        this.selectSchedulePreset(this.topicScheduleChoice || "tomorrow");
      } else {
        this.topicPublishAt = null;
      }
    },
    submitScheduledTopic() {
      this.validateName();
      this.validateDescription();
      let validateData =
        this.$utils("watchingTrim", this.topicForm.title) &&
        this.$utils("watchingTrim", this.topicForm.description);
      if (!validateData) {
        return;
      }
      if (this.topicForm.fileList && this.topicForm.fileList.length) {
        this.$message({
          type: "warning",
          message: "Remove attachments to schedule a topic (coming soon).",
        });
        return;
      }
      if (!this.topicPublishAt) {
        this.$message({
          type: "warning",
          message: "Pick a date and time to schedule.",
        });
        return;
      }
      const when = new Date(this.topicPublishAt);
      if (when.getTime() <= Date.now()) {
        this.$message({
          type: "warning",
          message: "Choose a time in the future.",
        });
        return;
      }
      const form = _.clone(this.topicForm);
      this.$store
        .dispatch("happilyvillageTownhall/scheduleTownhallPost", {
          type: "topic",
          form,
          huddles: this.huddleTag,
          publishAt: when,
        })
        .then(() => {
          this.addTopicModal = false;
          this.cancelTownHallModal();
          this.topicPublishMode = "now";
          this.topicPublishAt = null;
          this.topicScheduleChoice = "tomorrow";
          this.$message({ type: "success", message: "Topic scheduled." });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "Could not schedule the topic. Please try again.",
          });
        });
    },
    editTopic() {
      this.validateName();
      this.validateDescription();
      let validateData =
        this.$utils("watchingTrim", this.topicForm.title) &&
        this.$utils("watchingTrim", this.topicForm.description);
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = _.clone(this.topicForm);
        this.$store
          .dispatch("happilyvillageTownhall/editTopic", {
            form: form,
            id: id,
            huddles: this.huddleTag,
            asDraft: this.editingDraft,
          })
          .then(() => {
            this.addTopicModal = false;
            this.cancelTownHallModal();
          });
        this.$message({
          type: "success",
          message: "Topic has been updated",
        });
      }
    },
    saveDraftTopicForm() {
      this.validateName();
      this.validateDescription();
      let validateData =
        this.$utils("watchingTrim", this.topicForm.title) &&
        this.$utils("watchingTrim", this.topicForm.description);
      if (validateData) {
        setTimeout(() => {
          this.$store.dispatch(
            "happilyvillageTownhall/createTopicNew",
            this.topicForm
          );
          this.addTopicModal = false;
        }, 200);
      }
    },
    handleChange(file) {
      this.topicForm.fileList.push(file);
    },
    removeFileInList(uid) {
      const arr = this.topicForm.fileList;
      const result = arr.filter((file) => file.uid !== uid);
      this.topicForm.fileList = result;
    },
    fileExtension(name) {
      if (name) {
        let extentsion = name.split(".").reverse();
        return extentsion[0];
      } else {
        return "";
      }
    },
    validateName() {
      let title = this.$utils("watchingTrim", this.topicForm.title);
      this.validateTopicForm.title = true;
      if (title) {
        this.validateTopicForm.title = false;
      }
    },
    isMarkdown,
    validateDescription() {
      let description = stripMarkdown(this.topicForm.description || "").trim();
      this.validateTopicForm.description = true;
      if (description) {
        this.validateTopicForm.description = false;
      }
    },
    removeYear(dateTime) {
      let class_datetime = dateTime.split(" at");
      let newDateTime = class_datetime[0].slice(0, -4);
      return `${newDateTime.slice(0, -2)} at ${class_datetime[1]}`;
    },
    handleTopicActionCommand(command, row) {
      switch (command) {
        case "duplicate":
          this.cloneTopic(row, "duplicate");
          break;
        case "edit":
          this.cloneTopic(row, "edit");
          break;
        case "delete":
          this.deleteMenu(row);
          break;
      }
    },
    async cloneTopic(value, select) {
      // console.log('value',value)
      // Editing a draft keeps it a draft on save (asDraft is forwarded to the
      // edit action). Duplicating a draft makes a new published post, so only
      // an explicit edit sets the flag.
      this.editingDraft = select === "edit" && !!value && value.status === "draft";
      if (value.delete == "huddles" || value.draft_prev_delete == "huddles") {
        this.huddleTag = this.buildHuddleTagSelection(value.huddles);
      } else {
        this.huddleTag = [[EVERYONE_KEY]];
      }
      if (value.type == "topic") {
        this.resetValidateForm();
        this.setUser(this.userLogin, value);
        this.id = value.key;
        this.topicForm.title = value.title || "";
        this.topicForm.description = initialEditorValue(value);
        this.topicForm.commentEnabled = !value.comment_disable;
        this.topicForm.media = null; // TODO: Clone media function! - clone media from old post.
        this.topicForm.fileList = []; // TODO: Clone media function! - clone media from old post.
        this.topicForm.arrFileOld =
          value.arrFileOld.length > 0 ? value.arrFileOld : [];
        if (value.arrFile !== undefined) {
          for (const x in value.arrFile) {
            let item = {
              name: value.arrFile[x]["name"],
              size: value.arrFile[x]["size"],
              url: value.arrFile[x]["url"],
              uid: x,
              ckfile: "old",
              category: value.arrFile[x]["category"],
              update_date: value.arrFile[x]["update_date"],
            };
            this.topicForm.fileList.push(item);
          }
        }
        this.addTopicModal = true;
        if (select === "edit") {
          this.editTopicStatus = true;
        } else {
          this.editTopicStatus = false;
        }
      } else if (value.type == "poll") {
        let options = [];
        if (value.options) {
          value.options.map((data, index) => {
            options.push({ poll: data, statusNotEdit: false });
          });
        }
        this.resetValidateForm();
        this.setPoll(value);
        this.id = value.key;
        this.pollForm.creator = value.create_name;
        this.pollForm.title = value.title;
        this.pollForm.description = initialEditorValue(value);
        this.pollForm.polls = options;
        this.pollForm.commentEnabled = !value.comment_disable;
        this.pollForm.members = value.members;
        this.addPollModal = true;

        if (select === "edit") {
          this.editTopicStatus = true;
        } else {
          this.editTopicStatus = false;
        }
      } else if (value.type == "checklist") {
        this.resetValidateForm();
        this.setCheckList(value);
        // Coerce legacy string options into the canonical ChecklistItem
        // shape so the rich form renders consistently for both old and
        // new docs. Stable _key for v-for prevents type-switches from
        // re-mounting the row.
        const normalized = normalizeItems(value.options || []);
        const checklists = normalized.map((it, i) => ({
          _key: `ck_edit_${value.key || "x"}_${i}`,
          label: it.label,
          type: it.type,
          required: it.required,
          description: it.description || "",
          link: it.link || "",
        }));
        this.id = value.key;
        this.checklistForm.creator = value.create_name;
        this.checklistForm.title = value.title || "";
        this.checklistForm.description = value.description || "";
        this.checklistForm.checklists = checklists.length > 0 ? checklists : [
          { _key: `ck_edit_${value.key}_a`, label: "", type: CHECKLIST_ITEM_TYPES.SIMPLE, required: true, description: "", link: "" },
        ];
        this.checklistForm.dueDate = value.due_date || "";
        this.checklistForm.reminderRelative = Array.isArray(value.reminder_relative) ? value.reminder_relative.slice() : [];
        this.checklistForm.tags = Array.isArray(value.tags) ? value.tags.slice() : [];
        this.checklistForm.commentEnabled = !value.comment_disable;
        this.checklistForm.weeklyReminders = value.reminder;
        this.checklistForm.showRespondentsResults = value.respondents;
        this.checklistForm.members = Array.isArray(value.members) ? value.members.slice() : [];
        this.checklistForm.weeklyCofig = {
          day: value.reminder_day,
          time: value.reminder_time,
        };
        this.addChecklistModal = true;
        if (select === "edit") {
          this.editTopicStatus = true;
        } else {
          this.editTopicStatus = false;
        }
      }
    },
    deleteMenu(value) {
      this.$confirm(
        `Are you sure you would like to proceed with "${value.title}"? deleting This action cannot be undone.`,
        "Confirm to Delete",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("happilyvillageTownhall/deleteTopic", value);
          this.$message({
            type: "success",
            message: "Delete completed",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    cancelTownHallModal() {
      this.id = "";
      this.editTopicStatus = false;
      this.topicForm.title = "";
      this.topicForm.description = "";
      this.topicForm.commentEnabled = true;
      this.topicForm.media = null;
      this.topicForm.fileList = [];
      this.topicForm.arrFileOld = [];
      this.huddleTag = [["everyone"]];
      // this.user.pic = null;
      // this.user.firstname = "Firstname";
      // this.user.lastname = "Lastname";
      // this.user.name = "Firstname L";
      this.resetValidateForm();
    },
    resetValidateForm() {
      this.validateTopicForm.title = false;
      this.validateTopicForm.description = false;
      this.validatePollForm.title = false;
      this.validatePollForm.description=false;
      this.validateChecklistForm.title = false;
    },
    checkedImageFile(name) {
      if (
        this.fileExtension(name) == "JPEG" ||
        this.fileExtension(name) == "jpeg" ||
        this.fileExtension(name) == "gif" ||
        this.fileExtension(name) == "GIF" ||
        this.fileExtension(name) == "JPG" ||
        this.fileExtension(name) == "jpg" ||
        this.fileExtension(name) == "PNG" ||
        this.fileExtension(name) == "png"
      ) {
        return true;
      } else {
        return false;
      }
    },
    async createTopicModal() {
      await this.$store.dispatch(
        "happilyvillageTownhall/getAdviser",
        this.userLogin
      );
      this.cancelTownHallModal();
      this.topicPublishMode = "now";
      this.topicPublishAt = null;
      this.topicScheduleChoice = "tomorrow";
      this.setUser(this.userLogin);
      this.addTopicModal = !this.addTopicModal;
    },
    async openProgramTownHallComposerFromRoute() {
      if (!this.$route || !this.$route.query || this.$route.query.compose !== "program") {
        return;
      }

      const requestedType = String(this.$route.query.type || "topic").toLowerCase();
      if (requestedType === "poll") {
        this.canclePoll();
        await this.setPoll();
        this.addPollModal = true;
      } else if (requestedType === "checklist") {
        this.cancleCheckList();
        await this.setCheckList();
        this.addChecklistModal = true;
      } else {
        await this.createTopicModal();
      }

      this.huddleTag = [[PROGRAM_ONLY_KEY]];
      this.clearProgramComposerQuery();
    },
    clearProgramComposerQuery() {
      if (!this.$router || !this.$route || !this.$route.query) return;
      const query = { ...this.$route.query };
      delete query.compose;
      delete query.type;
      this.$router.replace({ query }).catch(() => {});
    },
    async setUser(userData, dataUser) {
      await this.$store.dispatch("happilyvillageTownhall/getCreator", userData);
      this.user.firstname = userData.firstname;
      this.user.lastname = userData.lastname;
      this.user.name = userData.firstname + " " + userData.lastname.charAt(0);
      if (userData.profilepic_small) {
        this.user.pic = userData.profilepic_small;
      } else if (userData.profilepic_crop) {
        this.user.pic = userData.profilepic_crop;
      } else if (userData.profilepic) {
        this.user.pic = userData.profilepic;
      } else {
        this.user.pic = null;
      }
      // this.creatorList.unshift({
      //   pic: null,
      //   name: this.user.name,
      // });

      if (dataUser) {
        var listData = _.find(this.creatorList, (item) => {
          // Try multiple matching strategies for better character matching
          return item.character_name === dataUser.create_name || 
                 item.name === dataUser.create_name ||
                 item.character_name === dataUser.create_name.replace(/\s+/g, "") ||
                 (item.character_name && dataUser.create_name && 
                  item.character_name.toLowerCase() === dataUser.create_name.toLowerCase());
        });
      }
      if (this.adviser) {
        this.topicForm.creator = "Harry (Happiness)";
      } else if (listData) {
        this.topicForm.creator = listData.name;
      } else {
        this.topicForm.creator = this.user.name;
      }
    },
    spanBgColor(value) {
      if (value.programOnly) {
        return "span-tag span-program-only";
      } else if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "span-tag bg-1d97f2";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "span-tag bg-ffbf1f";
            break;
          default:
            return "span-tag bg-ea183c";
        }
      } else if (value.team) {
        return "span-tag span-normal";
      }
    },
    spanTextTag(value) {
      if (value.programOnly) {
        return "Program only";
      } else if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "Delphinus";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "Leonos";
            break;
          default:
            return "Corvus";
        }
      } else if (value.team) {
        return value.value;
      }
    },
    huddleDisplayKey(value, index) {
      const rawKey = value && value.key !== undefined ? value.key : index;
      if (typeof rawKey === "string" || typeof rawKey === "number") {
        return rawKey;
      }
      return `huddle_${index}_${JSON.stringify(rawKey)}`;
    },
    buildHuddleTagSelection(huddles) {
      if (!Array.isArray(huddles) || huddles.length === 0) {
        return [[EVERYONE_KEY]];
      }
      const selected = huddles
        .map((huddle) => {
          const key = huddle && huddle.key;
          if (!key) return null;
          if (key === PROGRAM_ONLY_KEY || huddle.programOnly) {
            return [PROGRAM_ONLY_KEY];
          }
          const option = _.find(this.huddleTagData, (item) => {
            return String(item.value) === String(key);
          });
          return option ? [option.value] : null;
        })
        .filter(Boolean);
      return selected.length > 0 ? selected : [[EVERYONE_KEY]];
    },
    percentOfTotal(value, total) {
      const numerator = Number(value) || 0;
      const denominator = Number(total) || 0;
      if (denominator <= 0) return 0;
      return ((numerator / denominator) * 100).toFixed(1);
    },
    checklistOptionKey(item, index) {
      return `checklist_${index}_${item.type}_${item.label}`;
    },
    checklistResultKey(value, index) {
      return value && value.key ? value.key : `checklist_result_${index}`;
    },
    addMoreList() {
      this.checklistForm.checklists.push({
        _key: `ck_${Date.now()}_${this.checklistForm.checklists.length}`,
        label: "",
        type: CHECKLIST_ITEM_TYPES.SIMPLE,
        required: true,
        description: "",
        link: "",
      });
    },
    removeChecklistItem(index) {
      if (this.checklistForm.checklists.length <= 1) return;
      this.checklistForm.checklists.splice(index, 1);
    },
    // Date-picker stores 'YYYY-MM-DD'; the preview pill reads more
    // naturally with a short month + day like "Jun 14".
    formatChecklistDueDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value + "T00:00:00");
        if (Number.isNaN(d.getTime())) return value;
        return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
      } catch (e) {
        return value;
      }
    },
    addMorePoll() {
      this.pollForm.polls.push({ poll: "", statusNotEdit: true });
    },
    setDayReimind(value) {
      this.checklistForm.weeklyCofig.day = value;
    },
    setTimeReimind(value) {
      const time = value.split(" ").join(":00 ");
      this.checklistForm.weeklyCofig.time = time;
    },
    createChecklist() {
      this.validateNameChecklist();
      let validateData = this.$utils("watchingTrim", this.checklistForm.title);
      if (validateData) {
        this.$store
          .dispatch("happilyvillageTownhall/createChecklist", {
            form: this.checklistForm,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.addChecklistModal = false;
            this.cancleCheckList();
          });
        this.$message({
          type: "success",
          message: "New Topic has been created",
        });
      }
    },
    editChecklist() {
      this.validateNameChecklist();
      let validateData = this.$utils("watchingTrim", this.checklistForm.title);
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = _.clone(this.checklistForm);
        this.$store
          .dispatch("happilyvillageTownhall/editChecklist", {
            form: form,
            id: id,
            huddles: this.huddleTag,
            asDraft: this.editingDraft,
          })
          .then(() => {
            this.addChecklistModal = false;
            this.cancleCheckList();
          });
        this.$message({
          type: "success",
          message: "New Topic has been created",
        });
      }
    },

    validateNameChecklist() {
      let title = this.$utils("watchingTrim", this.checklistForm.title);
      this.validateChecklistForm.title = true;
      if (title) {
        this.validateChecklistForm.title = false;
      }
    },
    draftChecklist() {
      console.log("draftChecklist: functions <<<"); // TODO: draftChecklist
    },
    createPoll() {
      this.validateNamePoll();
      let validateData = this.$utils("watchingTrim", this.pollForm.title);
      if (validateData) {
        this.$store
          .dispatch("happilyvillageTownhall/createPoll", {
            form: this.pollForm,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.addPollModal = false;
            this.canclePoll();
          });
        this.$message({
          type: "success",
          message: "New poll has been created",
        });
      }
    },
    editPoll() {
      this.validateNamePoll();
      let validateData = this.$utils("watchingTrim", this.pollForm.title);
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = _.clone(this.pollForm);
        this.$store
          .dispatch("happilyvillageTownhall/editPoll", {
            form: form,
            id: id,
            huddles: this.huddleTag,
            asDraft: this.editingDraft,
          })
          .then(() => {
            this.addPollModal = false;
            this.canclePoll();
          });
        this.$message({
          type: "success",
          message: "Poll has been updated",
        });
      }
    },
    validateNamePoll() {
      let title = this.$utils("watchingTrim", this.pollForm.title);
      let description = stripMarkdown(this.pollForm.description || "").trim();
      this.validatePollForm.title = true;
      this.validatePollForm.description = true;
      if (title) {
        this.validatePollForm.title = false;
      }
      if(description){
        this.validatePollForm.description = false;
      }
    },
    draftPoll() {
      console.log("draftPoll: functions <<<"); // TODO: draftPoll
    },
    canclePoll() {
      this.pollForm.creator = "";
      this.pollForm.title = "";
      this.pollForm.description = "";
      this.pollForm.polls = [{ poll: "" }, { poll: "" }];
      this.pollForm.commentEnabled = true;
      this.huddleTag = [["everyone"]];
    },

    async setPoll(dataUser) {
      await this.$store.dispatch(
        "happilyvillageTownhall/getAdviser",
        this.userLogin
      );
      // this.canclePoll();
      await this.$store.dispatch(
        "happilyvillageTownhall/getCreator",
        this.userLogin
      );
      this.user.firstname = this.userLogin.firstname;
      this.user.lastname = this.userLogin.lastname;
      this.user.name =
        this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0);
      if (this.userLogin.profilepic_small) {
        this.user.pic = this.userLogin.profilepic_small;
      } else if (this.userLogin.profilepic_crop) {
        this.user.pic = this.userLogin.profilepic_crop;
      } else if (this.userLogin.profilepic) {
        this.user.pic = this.userLogin.profilepic;
      } else {
        this.user.pic = null;
      }

      if (dataUser) {
        var listData = _.find(this.creatorList, (item) => {
          return item.character_name == dataUser.create_name.replace(" ", "");
        });
      }
      if (this.adviser) {
        this.pollForm.creator = "Harry (Happiness)";
      } else if (listData) {
        this.pollForm.creator = listData.name;
      } else {
        this.pollForm.creator = this.user.name;
      }
    },
    cancleCheckList() {
      this.checklistForm.creator = "";
      this.checklistForm.title = "";
      this.checklistForm.description = "";
      this.checklistForm.checklists = [
        { _key: `ck_${Date.now()}_a`, label: "", type: CHECKLIST_ITEM_TYPES.SIMPLE, required: true, description: "", link: "" },
        { _key: `ck_${Date.now()}_b`, label: "", type: CHECKLIST_ITEM_TYPES.SIMPLE, required: true, description: "", link: "" },
      ];
      this.checklistForm.dueDate = "";
      this.checklistForm.reminderRelative = [];
      this.checklistForm.tags = [];
      this.checklistForm.members = [];
      this.checklistForm.showRespondentsResults = true;
      this.checklistForm.commentEnabled = true;
      this.checklistForm.weeklyReminders = true;
      this.huddleTag = [["everyone"]];
      this.checklistForm.weeklyCofig = {
        day: "Monday",
        time: "9:00 AM",
      };
    },
    async setCheckList(dataUser) {
      await this.$store.dispatch(
        "happilyvillageTownhall/getAdviser",
        this.userLogin
      );
      //this.cancleCheckList();
      await this.$store.dispatch(
        "happilyvillageTownhall/getCreator",
        this.userLogin
      );
      this.user.firstname = this.userLogin.firstname;
      this.user.lastname = this.userLogin.lastname;
      this.user.name =
        this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0);
      if (this.userLogin.profilepic_small) {
        this.user.pic = this.userLogin.profilepic_small;
      } else if (this.userLogin.profilepic_crop) {
        this.user.pic = this.userLogin.profilepic_crop;
      } else if (this.userLogin.profilepic) {
        this.user.pic = this.userLogin.profilepic;
      } else {
        this.user.pic = null;
      }
      if (dataUser) {
        var listData = _.find(this.creatorList, (item) => {
          return item.character_name == dataUser.create_name.replace(" ", "");
        });
      }
      if (this.adviser) {
        this.checklistForm.creator = "Harry (Happiness)";
      } else if (listData) {
        this.checklistForm.creator = listData.name;
      } else {
        this.checklistForm.creator = this.user.name;
      }
    },
    createModal(modal) {
      this.editingDraft = false;
      if (modal == "Topic") {
        this.createTopicModal();
      } else if (modal == "Poll") {
        this.canclePoll();
        this.setPoll();
        this.addPollModal = true;
      } else if (modal == "Checklist") {
        this.cancleCheckList();
        this.setCheckList();
        this.addChecklistModal = true;
      } else if (modal == "Reel") {
        this.openReelStudio();
      }
    },
    openReelStudio(reel = null) {
      this.editingReel = reel ? _.cloneDeep(reel) : null;
      this.reelStudioOpen = true;
    },
    reelSaved(reel) {
      this.editingReel = _.cloneDeep(reel);
      if (this.$refs.reelOutbox && this.$refs.reelOutbox.refresh) {
        this.$refs.reelOutbox.refresh(reel.id);
      }
    },
    reelPublished(reel) {
      this.contentMode = "reels";
      this.editingReel = null;
      this.$nextTick(() => {
        if (this.$refs.reelOutbox && this.$refs.reelOutbox.refresh) {
          this.$refs.reelOutbox.refresh(reel && reel.id);
        }
      });
    },
    mentionsTopPosition(value) {
      // 140
      let style = "-46px";
      if (value > 3) {
        style = "-146px";
      } else if (value == 3) {
        style = "-126px";
      } else if (value == 2) {
        style = "-86px";
      }
      return "top: " + style;
    },
    scrollIntoView() {
      const element = document.getElementById("comment_data_bottom");
      if (element) {
        element.scrollIntoView();
      }
    },
    async scrollToBottomComments() {
      for (let i = 0; i < 6; i++) {
        await this.$utils("waitingTime", 400);
        this.scrollIntoView();
      }
    },
    filterToFunction(node, keyword) {
      let space = keyword.split(" ");
      let comma = keyword.split(",");
      let commaAndSpace = keyword.split(", ");
      let keywordArr = comma;
      if (space.length > comma.length) {
        keywordArr = space;
      } else if (
        commaAndSpace.length > comma.length ||
        commaAndSpace.length > space.length
      ) {
        keywordArr = commaAndSpace;
      }
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordArr[i].trim() === node.data.email) {
              this.dynamicValidateForm.cascaderTo.push([
                "user_" + node.data.email,
              ]);
              this.changeDataTo(this.dynamicValidateForm.cascaderTo);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword.trim() === node.data.email) {
            this.dynamicValidateForm.cascaderTo.push([
              "user_" + node.data.email,
            ]);
            this.refreshInput = false;
            this.changeDataTo(this.dynamicValidateForm.cascaderTo);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
    backgroundBarColor(index) {
      // Retained for legacy callers (preview/create); returns brand-aligned color
      return "background-color: " + this.getPollBarColor(index - 1) + ";";
    },
    getPollBarColor(index) {
      // Design system aligned poll colors: cyan, brand-purple, success-green, warning-yellow
      const POLL_COLORS = ["#00BCD4", "#5F32A7", "#66BB6A", "#FBC02D"];
      return POLL_COLORS[((index % 4) + 4) % 4];
    },
    getPollBarWidth(index) {
      const members = (this.commentDetail && this.commentDetail.members) || [];
      const max = members.length ? Math.max.apply(null, members.map(function (v) { return Number(v) || 0; })) : 0;
      if (max <= 0) return 0;
      const count = Number(members[index]) || 0;
      return Math.max(0, Math.min(100, (count / max) * 100));
    },
    getPollPercent(index) {
      const members = (this.commentDetail && this.commentDetail.members) || [];
      const total = members.reduce(function (sum, v) { return sum + (Number(v) || 0); }, 0);
      if (total <= 0) return 0;
      const count = Number(members[index]) || 0;
      return Math.round((count * 100) / total);
    },
    async downloadExcel_Poll() {
      const _this = this
      let data = [];
      let dateNow = format(new Date(), "YYYYMMDD");
      for(const index in _this.commentDetail.options){
        let membersList = ''
        if(_this.membersPoll.length > 0 && _this.membersPoll[index]){
          membersList = _this.membersPoll[index].join(', ');
        }
        data.push({
          key: index,
          name: _this.commentDetail.options[index].options,
          count: _this.commentDetail.members[index],
          percent: Number(_this.commentDetail.options[index].green),
          voters: membersList,
        });
      }
      // this.exportActivityStatus = true;
      // this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = _this.commentDetail.title;
      ws.getCell("B3").value = _this.commentDetail.description || _this.commentDetail.title;
      ws.getCell("B4").value = _this.commentDetail.firstname + ' ' + _this.commentDetail.lastname;
      
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Poll Option",
        "Option Votes",
        "Option Vote %",
        "Voters",
      ];
      ws.getRow(6).font = { bold: true };
      ws.getRow(6).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        let _tmp = [
          "",
          item.name,
          item.count,
          item.percent,
          item.voters,
        ];
        ws.addRow(_tmp);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download =  `${globalfunc.truncateText(_this.commentDetail.title, 15)}-${dateNow}` + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          _this.$store.dispatch(
            "authen/addLogs",
            {
              company: _this.userLogin.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "townhall",
              status: "downloaded",
              user: _this.userLogin.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      // this.exportActivityStatus = false;
    },
    canEditPost(post) {
      // Check if user owns the post
      const isCreator = post.create_user === this.userLogin.email || post.email_create === this.userLogin.email;
      
      // Check if it's a Happily Character post (various formats)
      const isHappilyCharacterPost = 
        post.create_user === 'happily_charracter' || 
        post.create_user === 'happily_character' ||
        (post.create_user && typeof post.create_user === 'string' && post.create_user.toLowerCase().includes('happily')) ||
        (post.happily_user && post.happily_user !== '');
      
      // Debug logging - remove after testing
      if (isHappilyCharacterPost) {
        console.log('Happily Character Post Found:', {
          create_user: post.create_user,
          email_create: post.email_create,
          happily_user: post.happily_user,
          create_name: post.create_name
        });
      }
      
      // Allow editing if user is creator OR if it's a Happily Character post
      return isCreator || isHappilyCharacterPost;
    },
  },
};
</script>

<style lang="scss" scoped>
.th-content-nav {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 16px;
  padding: 4px;
  border: 1px solid #e2e4ea;
  border-radius: 10px;
  background: #fff;

  button {
    min-width: 112px;
    height: 36px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #626262;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .15s ease, color .15s ease;

    i { margin-right: 6px; }
    &:hover { color: #6c30cc; background: #fbf9ff; }
    &.active { color: #6c30cc; background: #f2ecfb; }
    &:focus-visible { outline: 2px solid #6c30cc; outline-offset: 2px; }
  }
}

.th-inbox-toggle {
  display: flex;
  justify-content: flex-end;
  margin: 18px 0;
}
.th-inbox-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e2e4ea;
  border-radius: 999px;
  padding: 6px 10px 6px 14px;
  transition: border-color 0.15s, background 0.15s;
}
.th-inbox-pill.on {
  background: #faf7ff;
  border-color: #d9c9f5;
}
.th-inbox-ic {
  font-size: 16px;
  color: #6c30cc;
}
.th-inbox-lbl {
  font-size: 13px;
  font-weight: 700;
  color: #4a4a4a;
}
.th-inbox-beta {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: #f2ecfb;
  color: #6c30cc;
  padding: 2px 7px;
  border-radius: 999px;
}
.th-schedule {
  border-top: 1px solid #eef0f5;
  padding-top: 16px;
}
.th-when-label {
  font-size: 13px;
  font-weight: 700;
  color: #4a4a4a;
  margin-bottom: 10px;
}
.th-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.th-preset {
  appearance: none;
  cursor: pointer;
  padding: 8px 15px;
  border-radius: 999px;
  border: 1px solid #e2e4ea;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}
.th-preset:hover {
  border-color: #c8b1ee;
  color: #6c30cc;
}
.th-preset.active {
  background: #f2ecfb;
  border-color: rgba(108, 48, 204, 0.4);
  color: #6c30cc;
}
.th-custom-picker {
  width: 100%;
}
.th-when-resolved {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
}
.th-when-resolved i {
  color: #6c30cc;
  font-size: 15px;
}
.th-schedule-note {
  font-size: 12px;
  line-height: 1.4;
  color: #8a8a8a;
}
.th-schedule-note.warn {
  color: #cc3030;
}
.program-only-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 8px 0;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid rgba(108, 48, 204, 0.18);
  border-radius: 8px;
}
.program-only-hint-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #f2ecfb;
  color: #6c30cc;
  font-size: 13px;
}
.program-only-hint-copy {
  flex: 1;
  min-width: 0;
}
.program-only-hint-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.005em;
  line-height: 1.35;
}
.program-only-hint-sub {
  margin-top: 3px;
  font-size: 12px;
  color: #626262;
  line-height: 1.5;
}
.span-program-only {
  background: #f2ecfb !important;
  color: #6c30cc !important;
}

.preview-overflow {
  overflow-x: auto;
  display: flex;
}
.image-preview {
  object-fit: cover;
  max-height: 300px;
}
.image-preview-one {
  width: 100%;
}
.image-preview-many {
  margin-right: 16px;
  width: 259px;
}
.barchart-style {
  border-radius: 4px;
}
.sub-title {
  text-transform: capitalize;
}
.bg-black-001 {
  background-color: rgba(000, 000, 000, 0.01);
}
.btn-add {
  font-size: 14px;
  height: 52px;
  width: 160px;
}
.btn-add.bigger,
.btn-cancel.bigger {
  font-weight: 400;
}
.icon-export {
  position: absolute;
  top: 3px;
  padding-left: 32px;
}
.grid-2-sesstion {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-2-sesstion.grid-2-detail {
  grid-template-columns: 1.3fr 1fr;
}
.grid-left {
  min-height: 893px;
  // No max-height: the right column can exceed this in dialogs with
  // many fields. CSS grid's default align-items: stretch then sizes
  // the left column to match — capping it leaves an empty strip
  // below the preview content.
  background-color: #eef0f5; // matches aq-preview-backdrop
  padding: 32px 36px;
  // Frame the live preview as a phone card floating on the tinted
  // stage — makes "Preview on Mobile" literal and reads as a real
  // device surface rather than loose content on grey.
  > .body {
    background: #fff;
    border-radius: 20px;
    padding: 24px 22px 26px;
    box-shadow: 0 12px 32px rgba(17, 24, 39, 0.1);
  }
}
.grid-left .aq-preview-eyebrow {
  margin-bottom: 18px;
}
.hv-compose-head {
  margin-bottom: 22px;
}
.hv-compose-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}
.hv-dialog-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.01em;
}
.grid-right {
  padding: 40px 40px 36px;
  background-color: #fff;
}
.hv-toggle-label {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 28px; // matches the 28px switch height for vertical centering
}
.bg-skeleton {
  background-color: #d8d8d8;
  border-radius: 3px;
  width: 100%;
}
.height-18 {
  height: 18px;
}
.height-32 {
  height: 32px;
}
.height-25 {
  height: 25px;
}
.btn-gray-outline {
  color: #6c30cc !important;
  font-weight: 700;
  height: 52px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.loading-box {
  border-radius: 4px;
  height: 48px;
  width: 100%;
  background-color: #f0f0f0;
  > .file {
    background-color: #e6e6e6;
    width: 48px;
    height: 48px;
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
  }
  > .name {
    width: calc(100% - 112px);
  }
  > .remove {
    transition: 0.3s;
    position: absolute;
    right: 0;
    width: 48px;
    font-size: 16px;
    &:hover > i {
      box-shadow: 0 0 10px 2px #f0f0f0;
    }
  }
}
.table-happily-village {
  font-size: 13px;
}
.span-tag {
  margin-right: 6px;
}
.button-outline {
  padding: 13px 16px;
  color: #6c30cc;
  font-size: 14px;
  font-weight: 600;
  border: 1px dashed #d8d2ec;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  &:hover {
    background-color: #f7f4fd;
    border-color: #6c30cc;
  }
}
.set-weekly-reminders {
  margin-top: 12px;
  padding: 16px 18px;
  word-break: break-word;
  background-color: #f7f8fb;
  border: 1px solid #eef0f5;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #b9bcc6;
}
.el-dropdown-link {
  text-decoration: underline;
  font-weight: 700;
  color: #b9bcc6;
}
.set-weekly-reminders.on {
  color: #4a4a4a;
  .el-dropdown-link {
    cursor: pointer;
    color: #6c30cc;
  }
}
.preview-checklist {
  margin: 17px 0;
  .card {
    padding: 11px 12px 15px 16px;
    border: 1px solid #00000033;
    border-width: 1px 1px 0px;
    border-radius: 2px 2px 0 0;
    .checkbox,
    .arrow,
    .list-label {
      background-color: #d8d8d8;
      height: 18px;
    }
    .checkbox {
      width: 18px;
      border-radius: 3px;
      margin-right: 15px;
    }
    .list-label {
      border-radius: 3px;
      width: 180px;
    }
    .arrow {
      margin-left: auto;
      width: 18px;
      border-radius: 18px;
    }
  }
  .shadow-inner {
    height: 4px;
    background-color: rgba(000, 000, 000, 0.1);
    border: 1px solid #00000033;
    border-width: 0 1px 1px;
    border-radius: 0 0 2px 2px;
    overflow: hidden;
    .show-score {
      height: 4px;
      background-color: #62bc43;
    }
    .show-score.green {
      background-color: #62bc43;
    }
    .show-score.red {
      background-color: #f44336;
    }
  }
}
.preview-checklist.real {
  .card {
    .checkbox,
    .arrow,
    .list-label {
      height: 18px;
      background-color: transparent;
    }
    .checkbox {
      margin-right: 15px;
      width: 12px;
      height: 12px;
      border: 3px solid #000000;
    }
    .list-label {
      font-size: 13px;
      font-weight: 700;
      padding-top: 2px;
      height: 16px;
      color: rgba(000, 000, 000, 0.8);
      width: 220px;
    }
    .arrow {
      margin-left: auto;
      width: 6px;
      height: 6px;
      border-radius: 0;
      transform: rotate(45deg);
      border: 2px solid #00000080;
      border-width: 2px 2px 0 0;
    }
  }
  .shadow-inner {
    height: 4px;
  }
}
.preview-poll {
  margin: 17px 0;
  .poll-card {
    height: 50px;
    border-radius: 3px;
    background-color: #d8d8d8;
  }
}
.preview-poll.real {
  margin: 17px 0;
  position: relative;
  height: 50px;
  .show-score {
    position: absolute;
    height: 50px;
    top: 0;
    border-radius: 6px;
  }
  .show-score.green {
    background-color: #62bc43;
  }
  .show-score.red {
    background-color: #f44336;
  }

  .poll-card {
    position: absolute;
    background-color: #ebebeb;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    color: #4a4a4a;
    width: 100%;
  }
  .shadow {
    position: absolute;
    background-color: #adadad;
    border-radius: 0 0 6px 6px;
    height: 12px;
    margin: auto;
    top: 40px;
    left: 2px;
    width: calc(100% - 4px);
  }
}

.poll-results {
  .poll-row {
    margin-bottom: 18px;
    &:last-child { margin-bottom: 0; }
  }
  .poll-row-label {
    font-family: 'Lato', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #4a4a4a;
    margin-bottom: 6px;
    word-break: break-word;
  }
  .poll-row-bar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .poll-row-track {
    flex: 1;
    height: 18px;
    background: rgba(26, 26, 46, 0.06);
    border-radius: 10px;
    overflow: hidden;
  }
  .poll-row-fill {
    height: 100%;
    border-radius: 10px;
    transition: width .6s cubic-bezier(0.2, 0.8, 0.2, 1);
    min-width: 2px;
  }
  .poll-row-percent {
    min-width: 38px;
    text-align: right;
    font-family: 'Lato', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #a0a0a0;
    font-variant-numeric: tabular-nums;
  }
}
.preview-wrroning {
  background-color: #f5f5fa;
  padding: 12px 16px;
  border-radius: 10px;
  color: rgba($color: #000000, $alpha: 0.8);
}
.button-remove-list {
  position: absolute;
  right: 21px;
  top: -16px;
  opacity: 0.8;
  cursor: pointer;
}
.el-dropdown-link-ceate {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}
.create-text-in-button {
  padding: 0;
  position: relative;
  width: 60px;
  .label-create {
    position: absolute;
    left: 50%;
    right: 50%;
  }
}
.el-select-dropdown__item.is-disabled {
  opacity: 0.6;
}

.comment-contrainer {
  position: relative;
  padding: 60px 40px 40px;
  .comment-card {
    height: 538px;
    background-color: #fff;
    box-shadow: 0px 2px 4px #00000029;
    .comment-box {
      height: 490px;
      .comment {
        min-height: calc(70px - 36px);
        padding: 18px;
        display: grid;
        grid-template-columns: auto 60px;
        .content-comment {
          display: grid;
          grid-template-columns: 44px auto;
        }
        .content-comment-sub {
          display: grid;
          grid-template-columns: 24px 44px auto;
        }
        .img-preview {
          width: auto;
          max-width: 200px;
          max-height: 400px;
          object-fit: cover;
          background-color: rgba($color: #afafaf, $alpha: 0.4);
        }
      }
    }
    .no-comment {
      padding-top: 60px;
      text-align: center;
      color: #404243;
      font-size: 14px;
    }
    .input-container {
      background-color: #ebebeb;
      padding: 0 16px;
      height: 48px;
      display: grid;
      grid-template-columns: 44px auto 56px;
      .input-contain {
        background-color: #fff;
        border-radius: 3px;
        height: 30px;
        .reply-tag {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 3px;
          color: #afafaf;
          font-size: 11px;
          font-weight: 700;
          padding: 3px 6px 2px;
        }
      }
      .input-box {
        background-color: #fff;
        border: 0;
        border-radius: 3px;
        outline: 0;
        height: 30px;
        padding: 0 8px;
        width: calc(100% - 16px);
      }
      .mention-container {
        background-color: #fff;
        position: absolute;
        top: 0;
        max-height: 140px;
        padding: 2px 0;
        width: calc(100%);
        border-radius: 2px;
        box-shadow: 1px 1px 4px #ccc;
        .memeber-box {
          padding: 0 8px;
          height: 40px;
          font-size: 13px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background-color: rgba($color: #ccc, $alpha: 0.4);
          }
        }
      }
    }
  }
}

// Town Hall Table - Fixed Actions Column with Scrollable Content
.townhall-table-wrapper {
  .townhall-sessions-table {
    // Enable horizontal scrolling for table content
    overflow-x: auto;
    border-radius: 8px;
    
    // Table body styling
    .el-table__body-wrapper {
      .el-table__row {
        td {
          // Name styling - matching campaigns reference
          .name-medium {
            font-weight: 700;
            color: #111827;
            line-height: 1.4;
          }

          // Link styling for engagement - using brand primary color
          .link, .engagement-link {
            color: #6C30CC;
            font-weight: 500;
            transition: color 0.2s ease;
            cursor: pointer;

            &:hover {
              color: #5A28A8;
            }
          }
        }
      }
    }

    // Enhanced tag styling for huddle badges
    .span-tag {
      font-size: 11px;
      font-weight: 600;
      padding: 3px 8px;
      border-radius: 12px;
      margin-right: 4px;
      letter-spacing: 0.3px;
    }
  }
}

// Action menu styles - matching campaigns reference
.campaign-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.campaign-actions-trigger {
  width: 32px;
  height: 32px;
  border: 1px solid #E5E7EB;
  border-radius: 999px;
  background: #FFFFFF;
  color: #4B5563;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.campaign-actions-trigger:hover,
.campaign-actions-trigger:focus {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #111827;
  outline: none;
}

.campaign-actions-trigger i {
  font-size: 16px;
  font-weight: 700;
}

.hv-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #eef0f5;
}
.hv-dialog-footer .el-button {
  min-width: 120px;
}
/* Brand the primary submit button purple — see university.vue for the
   matching block; same drift was happening in all three Town Hall
   dialogs. */
.hv-dialog-footer .el-button--primary {
  background-color: #6c30cc !important;
  border-color: #6c30cc !important;
  color: #fff !important;
  box-shadow: 0 1px 2px rgba(108, 48, 204, 0.18) !important;
}
.hv-dialog-footer .el-button--primary:hover,
.hv-dialog-footer .el-button--primary:focus {
  background-color: #522698 !important;
  border-color: #522698 !important;
  color: #fff !important;
}

/* Checklist authoring — richer per-item rows ported from the RN
   ChecklistCreate layout. The label gets a full row; the type /
   required / remove controls share a tidy second row so the input
   never gets squeezed into ~150px on a 480px dialog column. */
.ck-item-row {
  margin-top: 4px;
}
.ck-item-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}
.ck-item-label {
  width: 100%;
}
.ck-item-type {
  flex: 1 1 200px;
  max-width: 240px;
}
.ck-item-required {
  flex: 0 0 auto;
  margin-left: auto;
  margin-right: 4px;
}
.ck-item-remove {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #8a8a8a;
  cursor: pointer;
  font-size: 18px;
  transition: color .15s ease, background .15s ease;
  padding: 0;
}
.ck-item-remove:hover {
  color: #cc3030;
  background: rgba(204, 48, 48, 0.06);
}
.ck-reminder-relative .el-checkbox + .el-checkbox {
  margin-left: 16px;
}
.mt-8 { margin-top: 8px; }

/* Preview — additions to mirror RN's ChecklistView surface. */
.ck-preview-due-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef0f5;
  color: #5b6373;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.ck-preview-due-pill i {
  font-size: 12px;
}
.ck-preview-desc {
  font-size: 13px;
  line-height: 1.55;
  color: #4a4a4a;
  white-space: pre-line;
  word-break: normal;
  overflow-wrap: break-word;
}
.ck-preview-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 16px;
  padding: 0 5px;
  margin-left: 6px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  vertical-align: middle;
}
.ck-preview-type-badge.is-ack {
  background: #fff3d6;
  color: #b87a00;
}
.ck-preview-type-badge.is-link {
  background: #f2ecfb;
  color: #6c30cc;
}
.ck-preview-type-badge i {
  font-size: 11px;
}
.ck-preview-optional-tag {
  display: inline-block;
  margin-left: 6px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a8a8a;
}
.ck-preview-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ck-preview-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f5f5fa;
  color: #5b6373;
  font-size: 11px;
  font-weight: 600;
}
</style>

<style lang="scss">
// Global override for engagement link colors in Town Hall
#townHall .townhall-sessions-table {
  .engagement-link,
  .fc-00B7EE,
  [style*="color: #00B7EE"],
  .link {
    color: #6C30CC !important;

    &:hover {
      color: #5A28A8 !important;
    }
  }
}

#townHall .create.el-dropdown {
  .create-btn.el-button--primary {
    background-color: #32c2d5;
    border-color: #32c2d5;
    padding: 9px 16px;
    font-weight: 600;
    border-radius: 8px;
    transition: background-color 140ms ease, border-color 140ms ease, transform 80ms ease;
    display: inline-flex;
    align-items: center;
    gap: 0;
    .el-icon-arrow-down {
      margin-left: 6px;
      font-size: 12px;
      transition: transform 180ms ease;
    }
    &:hover, &:focus {
      background-color: #2ba7b8;
      border-color: #2ba7b8;
    }
    &:active {
      transform: translateY(1px);
    }
  }
}
.upload-demo {
  height: 52px;
  margin-bottom: 28px;
  > .el-upload--picture-card {
    width: 0;
    height: 0;
    border-width: 0;
    line-height: 0;
  }
}
.poll-modal,
.checklist-modal,
.comments-modal,
.topic-modal {
  .el-dialog__header {
    padding: 0;
    z-index: 2;
    position: relative;
  }
  .el-dialog__body {
    padding: 0;
  }
}
#topicModalTopic,
#topicModalChecklist,
#topicModalPoll {
  .grid-2-auto {
    gap: 16px;
  }
  .title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a8a8a;
    margin: 18px 0 6px;
  }
  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid #e2e4ea;
    border-radius: 8px;
    background: #fff;
    font-weight: 400;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .el-input__inner:hover,
  .el-textarea__inner:hover {
    border-color: #d3d6df;
  }
  /* The MarkdownEditor (topic Description, poll Caption) owns its own
     bordered frame + focus ring, so flatten the textarea inside it —
     otherwise the field shows a double border. */
  .md-editor .el-textarea__inner,
  .md-editor .el-textarea__inner:hover,
  .md-editor .el-textarea__inner:focus {
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  .name > .el-input__inner {
    font-size: 16px;
    font-weight: 500;
  }
  .el-input__inner {
    font-size: 14px;
  }
  .profiel-selected {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    left: 14px;
  }
  .creator-profile .el-input__inner {
    padding-left: 56px;
  }
  .el-textarea__inner {
    padding: 16px;
    font-size: 16px;
  }
  .el-date-editor.el-input,
  .el-select {
    width: 100%;
  }
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-menu {
    background-color: transparent;
  }
  .el-date-editor .el-range-separator {
    width: 6%;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    font-size: 10px;
    padding-top: 0px;
  }
  .el-form-item__label {
    line-height: 40px;
  }
  .el-cascader__tags .el-tag:not(.is-hit) {
    border-color: #6c30cc;
    background-color: #6c30cc24;
    color: #6c30cc;
    font-size: 15px;
    height: 30px;
    .el-tag .el-icon-close {
      background-color: #6c30cc;
      color: #6c30cc;
    }
  }
}

/* Town Hall list — type pill tints per content type. Checklist
   inherits the default qd-type-pill purple. Topic is neutral grey,
   Poll is warm yellow — mirrors the visual language used by the
   RN feed badges so admins and members read the same signal. */
.qd-type-pill.th-type-topic {
  background: #eef0f5;
  color: #5b6373;
}
.qd-type-pill.th-type-poll {
  background: #fff7e6;
  color: #b87a00;
}
.qd-type-pill.th-type-checklist {
  background: #f2ecfb;
  color: #6c30cc;
}

/* Brand-purple chrome shared by all three Town Hall compose dialogs
   (Topic / Poll / Checklist). Lives in the unscoped block because
   Vue's scope hash doesn't attach to Element UI's internal DOM
   (.el-checkbox__inner, .el-input__inner, etc.). Scoped to the three
   form ids so it never bleeds into other dialogs on the page. */
#topicModalTopic .el-checkbox__input.is-checked .el-checkbox__inner,
#topicModalPoll .el-checkbox__input.is-checked .el-checkbox__inner,
#topicModalChecklist .el-checkbox__input.is-checked .el-checkbox__inner,
#topicModalTopic .el-checkbox__input.is-indeterminate .el-checkbox__inner,
#topicModalPoll .el-checkbox__input.is-indeterminate .el-checkbox__inner,
#topicModalChecklist .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6c30cc;
  border-color: #6c30cc;
}
#topicModalTopic .el-checkbox__input.is-checked + .el-checkbox__label,
#topicModalPoll .el-checkbox__input.is-checked + .el-checkbox__label,
#topicModalChecklist .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #6c30cc;
}
#topicModalTopic .el-checkbox__inner:hover,
#topicModalPoll .el-checkbox__inner:hover,
#topicModalChecklist .el-checkbox__inner:hover,
#topicModalTopic .el-checkbox__input:not(.is-disabled):hover .el-checkbox__inner,
#topicModalPoll .el-checkbox__input:not(.is-disabled):hover .el-checkbox__inner,
#topicModalChecklist .el-checkbox__input:not(.is-disabled):hover .el-checkbox__inner {
  border-color: #6c30cc;
}
#topicModalTopic .el-checkbox__input.is-focus .el-checkbox__inner,
#topicModalPoll .el-checkbox__input.is-focus .el-checkbox__inner,
#topicModalChecklist .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #6c30cc;
}
#topicModalTopic .el-select .el-input.is-focus .el-input__inner,
#topicModalPoll .el-select .el-input.is-focus .el-input__inner,
#topicModalChecklist .el-select .el-input.is-focus .el-input__inner,
#topicModalTopic .el-select .el-input__inner:focus,
#topicModalPoll .el-select .el-input__inner:focus,
#topicModalChecklist .el-select .el-input__inner:focus,
#topicModalTopic .el-date-editor .el-input__inner:focus,
#topicModalPoll .el-date-editor .el-input__inner:focus,
#topicModalChecklist .el-date-editor .el-input__inner:focus,
#topicModalTopic .el-textarea__inner:focus,
#topicModalPoll .el-textarea__inner:focus,
#topicModalChecklist .el-textarea__inner:focus,
#topicModalTopic .el-input__inner:focus,
#topicModalPoll .el-input__inner:focus,
#topicModalChecklist .el-input__inner:focus {
  border-color: #6c30cc;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.1);
}
#topicModalTopic .el-date-editor .el-input__icon,
#topicModalPoll .el-date-editor .el-input__icon,
#topicModalChecklist .el-date-editor .el-input__icon,
#topicModalTopic .el-input__suffix .el-icon-arrow-up,
#topicModalPoll .el-input__suffix .el-icon-arrow-up,
#topicModalChecklist .el-input__suffix .el-icon-arrow-up {
  color: #8a8a8a;
}

/* Brand the Topic schedule control's segmented radio (Element's
   default is cyan) and square its outer corners to the 8px button
   radius used across the design system. */
#topicModalTopic .th-schedule .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #6c30cc;
  border-color: #6c30cc;
  box-shadow: -1px 0 0 0 #6c30cc;
  color: #fff;
}
#topicModalTopic .th-schedule .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 8px 0 0 8px;
}
#topicModalTopic .th-schedule .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 8px 8px 0;
}
</style>
